export const en_IN = {
  bbrText: 'Book Banquet Room',
  welcomeToText: 'Welcome to',
  loginText: 'Login',
  emailText: 'Email Id',
  PasswordText: 'Password',
  forgotPassword: 'Forgot Password',
  login_identifier_placeholder: 'Email or mobile number',
  login_next: 'Next',
  login_use_another_method: 'Use another method',
  login_back: 'Back',
  login_otp_sent_message: "We've sent a verification code to",
  login_enter_otp: 'Enter 6-digit code',
  login_verify_and_login: 'Verify & Login',
  login_resend_code: 'Resend Code',
  login_resend_in: 'Resend in',
  login_sending: 'Sending...',
  login_didnt_receive_code: "Didn't receive the code?",
  login_enter_email_or_mobile: 'Enter your email or mobile number to continue',
  reset_password_title: 'Reset Password',
  reset_password_codePlaceholder: 'Enter code',
  reset_password_text1: 'You will receive a verification code at',
  reset_password_text2:
    'Please enter the code below to complete the verification of your email. The verification of the email is mandatory before login.',
  updateCustomerDetails: 'Update Customer Details',
  password_reset_success_message: 'Password has been reset successfully',
  status_change_success_message: 'Status has been change successfully',
  profile_reset_success_message: 'Profile has been updated Successfully',
  code_validated_success_message: 'Code validated successfully',
  tryAgainMessage: 'Please try again',
  prev_text: 'Previous',
  next_text: 'Next',
  something_went_wrong: 'An unexpected error occurred. Please try again.',
  bookingRefNoText: 'Booking Reference No.',
  beoRefNoText: 'BEO Reference No.',
  beo_add_event_detail: 'Add Event Detail',
  beo_edit_event_detail: 'Edit Event Detail',
  beo_add_event: 'Add event',
  beo_edit_event: 'Edit event',
  beo_guests_count: '{count} guests',
  bookingMoNo: 'Mobile No.',
  clearText: 'Clear',
  clear_filter_text: 'Clear Filter',
  no_data_available: 'No data available',
  no_bookings_available: 'No Bookings Available',
  no_bookings_available_for_the_day: 'No bookings available for the day',
  action_text: 'Actions',
  continue_text: 'Continue',
  filter_text: 'Filters',
  monthText: 'Month',
  todayText: 'Today',
  weekText: 'Week',
  dayText: 'Day',
  venueAvailabilityText: 'Availability Matrix',
  venue_availability_available: 'Available',
  venue_availability_enquiry: 'Enquiry',
  venue_availability_no_bookings: 'No bookings for this slot.',
  venue_availability_booking_count: '{0} booking',
  venue_availability_bookings_count: '{0} bookings',
  venue_availability_held: 'Held',
  venue_availability_unavailable: 'Not available',
  venue_availability_empty: 'No venues or parts of day to show.',
  venue_availability_all_venues: 'All venues',
  highDemand_text: 'HIGH DEMAND',
  actualization_text: 'ACTUALIZED',
  finalize_actualization_button: 'Finalize Actualization',
  finalize_actualization_confirm_title: 'Finalize actualization?',
  finalize_actualization_confirm_message:
    'Once finalized, actualization details cannot be edited. This will lock all event charges, add-ons, drinks, guest counts, discounts, and final bill values for this booking.',
  finalize_actualization_not_all_actualized_confirm:
    'Not all line items are actualized. Are you sure you want to proceed?',
  finalize_actualization_success: 'Actualization finalized successfully.',
  reopen_actualization_button: 'Reopen Actualization',
  reopen_actualization_confirm_title: 'Reopen actualization?',
  reopen_actualization_confirm_message:
    'This will unlock actualization and booking edits for all line items on this booking. A history entry will be recorded for each line item.',
  bookingDetail_status_actualization_finalized: 'ACTUALIZATION FINALIZED',
  bookingDetail_badge_complementary: 'Complementary',
  move_booking_menu_label: 'Move to another date',
  move_booking_dialog_title: 'Move booking',
  move_booking_dialog_subtitle:
    'Select a new event date. The booking will be validated for venue availability before it is moved.',
  move_booking_current_date_label: 'Current event date: {0}',
  move_booking_new_date_label: 'New event date',
  move_booking_reason_label: 'Reason',
  move_booking_reason_optional: 'Optional — recorded in booking history',
  move_booking_confirm_button: 'Move booking',
  move_booking_success: 'Booking moved successfully.',
  move_booking_past_date_error: 'Cannot move booking to a past date.',
  move_booking_same_date_error: 'Please select a different date from the current event date.',
  confirmedText: 'CONFIRMED',
  tentativeText: 'TENTATIVE',
  awaitingConfirmationText: 'AWAITING CONFIRMATION',
  waitListText: 'WAITLISTED',
  cancelledText: 'CANCELLED',
  cancelRequestText: 'CANCEL REQUEST',
  blocked_text: 'BLOCKED',
  expired_text: 'EXPIRED',
  hourlyPricing1: 'Hourly Pricing',
  hourlyPricing2: '(Minimum Revenue and Fixed Hall Rental will not applicable if hourly pricing is seleted).',
  pricePerHour: 'Price Per Hour',
  originalPricePerHour: 'Original Price Per Hour',
  overridePricePerHour: 'Override Price Per Hour',
  originalTotalRental: 'Original Total Rental',
  pricePerHourMinValue: 'Price per hour cannot be 0',
  pricePerHourMaxValue: 'Hourly rate cannot exceed 10,00,000',
  menu_title_addOns: 'Add-ons',
  new_booking_addons_search_selected: 'Search selected add-ons',
  new_booking_addons_browse: 'Browse Add-ons',
  new_booking_addons_unit_price: 'Unit Price',
  new_booking_addons_total_column: 'Total',
  new_booking_addons_total: 'Add-ons Total',
  new_booking_addons_search_catalog: 'Search add-ons...',
  new_booking_addons_all_categories: 'All',
  new_booking_addons_selected_count: '{count} selected',
  new_booking_addons_add_selected: 'Add Selected',
  new_booking_addons_none_selected: 'No add-ons selected yet. Use Browse Add-ons to add items.',
  new_booking_addons_empty_title: 'No add-ons selected yet.',
  new_booking_addons_empty_description: 'Use Browse Add-ons to add items for this venue.',
  new_booking_addons_already_added: 'Added',
  new_booking_addons_per_quantity: '/ quantity',
  new_booking_addons_per_guest: '/ guest',
  fileSizeTooLarge: 'File size too large',
  bookingDetailsModalHeadingChangeBooking: 'Change Booking',
  bookingDetailsModalBodyMessageChangeBooking: 'Are you sure! You want to change this booking?',
  bookingDetailsModalBodyMessageConfirmBooking: 'Are you sure you want to confirm this booking?',
  bookingDetailsModalConfirmButton: 'Confirm',
  bookingDetailsModalBodyMessageTentativeBooking: 'Are you sure you want to change this booking to Tentative?',
  bookingDetailsModalBodyMessageAwaitingConfirmation:
    'Are you sure you want to move this booking to Awaiting Confirmation?',
  bookingDetailsModalAwaitingConfirmationButton: 'Continue',
  bookingDetailsModalBodyMessageCancelBooking:
    'Are you sure you want to cancel this booking? This cannot be undone. Please select a reason for cancellation.',
  bookingDetailsCancelBookingReason: 'Enter the reason for cancellation',
  bookingDetailsDeletionBookingReason: `You're about to permanently delete this booking from our system. This action cannot be undone. Please provide a reason for deletion.`,
  bookingDetailsCancelBooking: 'Cancel Booking',
  bookingDetailsDeleteBooking: 'Delete Booking',
  bookingDetailsDeleteBookingButton: 'Confirm Deletion',
  deleteReasonRequired: 'Delete Reason is Required',
  bookingList_deletedReason: 'Deleted Reason',
  bookingList_deletedBy: 'Deleted By',
  bookingDetailsDeletionPlaceholder:
    'Enter the reason for deletion (e.g., duplicate booking, incorrect details, customer request)...',
  bookingDetailsChangeToTentativeBooking: 'Change To Tentative',
  bookingDetailsChangeToAwaitingConfirmation: 'Awaiting Confirmation',
  bookingDetail_statusInfo_awaitingConfirmation: 'Contract shared. Awaiting client confirmation.',
  bookingDetailsConfirmBooking: 'Confirm Booking',
  bookingDetailsProcessRefund: 'Process Refund',
  bookingDetailsEditBooking: 'Edit Booking',
  bookingDetailsCancelReason: 'Cancel Reason',
  bookingDetailsHallRental: 'Hall Rental',
  BookingDetailButonTextCancel: 'Cancel',
  BookingDetailButonTextEdit: 'Edit',
  BookingDetailButonTextClone: 'Clone',
  hourlyPricingText1: 'Hourly Rate:',
  hourlyPricingText2: 'per hour (guests will be charged based on the duration of their event).',
  bookingDetailsAddPayment_newButton: 'Add New Payment',
  bookingDetails_perPerson: 'per person',
  bookingDetails_perHour: 'per hour',
  bookingDetailsAddPayment_paymentMethod: 'Payment Method',
  bookingDetailsStartDate: 'Start Date',
  bookingDetailsEndDate: 'End Date',
  bookingDetailsNumberOfRooms: 'Number of Rooms',
  bookingDetailsRoomType: 'Room Type',
  bookingDetailsMealPlan: 'Meal Plan',
  bookingDetailsMealPlanPrice: 'Meal Plan Price',
  bookingDetailsAmountRefund: 'Amount Refunded',
  bookingDetailsRefundDate: 'Refund Date',
  bookingDetailsRefundReferenceNumber: 'Refund Reference Number',
  WAITLISTED: 'WAITLISTED',
  CANCELLED: 'CANCELLED',
  CONFIRMED: 'CONFIRMED',
  TENTATIVE: 'TENTATIVE',
  CREATED: 'CREATED',
  EDITED: 'EDITED',
  editBooking_room_checkIn_text: 'Check In',
  editBooking_room_checkOut_text: 'Check Out',
  editBooking_room_date_validation: 'Check Out Date is greater than Check In Date',
  editBooking_room_date_validationForSame: 'Check In and Check Out date cannot be same',
  customerDetailsPhoneNumber: 'Phone No',
  customerDetailsRoles: 'Roles',
  customerDetailsEmailId: 'Email Id',
  customerDetailsCompanyName: 'Company Name',
  customerDetailsPlaceOfEvent: 'Place of Event',
  customerDetailsAddressOfEvent: 'Address of Event',
  customerDetailsAddress: 'Address',
  customerDetailsDesignation: 'Designation',
  customerDetailsGST: 'GSTIN',
  customerDetailsCity: 'City',
  tabsPaymentDetail: 'Payment Detail',
  venueDetailsTabsExpected: 'Expected Guests',
  venueDetailsTabsGuaranteed: 'Guaranteed Guests',
  bookingHistoryTabsDate: 'Date',
  bookingHistoryTabsEditedBy: 'Edited by',
  bookingHistoryTabsUpdated: 'Updated',
  bookingHistoryTabsChanges: 'Changes',
  bookingHistoryTabsEditedReason: 'Edited Reason',
  bookingHistoryTabsHallRental: 'Hall Rental',
  bookingHistoryTabsPricePerPerson: 'Price per Person',
  bookingHistoryTabsPricePerHour: 'Price per Hour',
  bookingHistoryTabsMinimumRevenue: 'Minimum Revenue',
  bookingHistoryTabsGuests: 'Guests',
  bookingHistoryTabsActualCost: 'Total Cost',
  bookingHistoryTabsEditedStatus: 'Status',
  bookingHistoryTabsHistoryNotFound: 'History not found',
  createNewCompany: 'Add new Company',
  venueTitle: 'Venue',
  venueName: 'Name',
  venueListTaxOnGuestCharge: 'GST on Guest Charge',
  venueListTaxOnHallRental: 'GST on Hall Rental',
  venue_text_taxGroupOnGuestCharge: 'Tax Group on Guest Charge',
  venue_text_taxGroupOnHallRental: 'Tax Group on Hall Rental',
  venue_text_taxGroupOnServiceCharge: 'Tax Group on Service Charge',
  editText: 'Edit',
  deleteText: 'Delete',
  confirmDeletedText: 'Are you sure you want to delete this?',
  delete_cannot_undo_text: 'This action cannot be undone.',
  show24HourClock: 'Show 24 Hour Clock',
  viewBookingDetails: 'View Booking Details',
  convertIntoBooking: 'Convert into Booking',
  rfq_mark_as_lost: 'Mark as Lost',
  rfq_view_calendar: 'View Calendar',
  booking_diary: 'Booking Diary',
  booking_diary_subtitle: 'View bookings, availability and events at a glance.',
  booking_diary_legend: 'Legend',
  booking_diary_legend_programming_event: 'Programming event',
  converted: 'Converted',
  common_button_back: 'Back',
  common_button_save: 'Save',
  common_button_update: 'Update',
  addOn_button_add: 'New Add-ons',
  addOn_column_category: 'Add-on Category',
  add_on_category_code: 'Category Code',
  add_on_category_name: 'Name',
  add_on_category_service_charge: 'Is Service Charge Applicable?',
  common_column_add: 'Add',
  common_column_edit: 'Edit',
  addOn_column_maxCount: 'Max Count',
  addOn_column_price: 'Price',
  addOn_column_type: 'Add-on Type',
  addOn_text_category: 'Add-on category',
  addOn_text_name: 'Add-on Name',
  addOn_text_price: 'Price',
  addOn_text_taxCode: 'Tax Codes',
  addOn_text_taxGroup: 'Tax Group',
  addOn_text_type: 'Add-on type',
  addOn_title_add: 'Add Add-ons',
  addOn_information_text: 'Add-on Information',
  upload_image_text: 'Upload Image',
  upload_image_button: 'Save',
  addOn_upload_image_success_text: 'Image uploaded successfully',
  addOn_title_edit: 'Edit Add-ons',
  addOn_title_list: 'Add-ons',
  addOn_list_subtitle: 'Used in venue configurations and booking line items for extras guests can purchase.',
  ycs_addOns_tab_label: 'YCS Add-ons',
  ycs_addOnCategories_tab_label: 'YCS Add-on categories',
  ycs_paymentMethods_tab_label: 'YCS Payment methods',
  ycs_taxCodes_tab_label: 'YCS Tax codes',
  ycs_column_ref_id: 'Ref ID',
  ycs_column_tax_type: 'Type',
  ycs_column_engine_tax_code: 'Engine tax code',
  ycs_sync_button_label: 'Sync from YCS',
  addOn_title_maxCount: 'Max count',
  bookings_placeholder_selectVenues: 'Select Venues',
  bookings_text_month_bookings_label: 'Bookings',
  bookings_text_month_occupancy_label: 'Occupancy',
  bookings_text_showCancelledEvents: 'Show Cancelled Events',
  bookings_text_send_email: 'Send Email',
  bookingDetails_text_bookingRef: 'Booking Reference',
  bookingDetail_guestCountsCompact: '{0} ({1} exp)',
  bookingDetail_summary_total: 'Total',
  bookingDetail_summary_paid: 'Paid',
  bookingDetail_summary_due: 'Due',
  bookingDetail_paymentStatus_label: 'Payment status',
  bookingDetail_paymentStatus_pending: 'PENDING PAYMENT',
  bookingDetail_paymentStatus_partial: 'PARTIAL PAYMENT',
  bookingDetail_paymentStatus_paidFull: 'PAID IN FULL',
  bookingDetail_header_customerPrefix: 'Customer:',
  bookingDetail_more_sendProposal: 'Send Proposal',
  bookingDetail_paymentPendingWarning: 'Payment pending: {0} is due. Consider collecting advance before the event.',
  /** Use {amount} and optionally {paid} — UI bolds these segments. */
  bookingDetail_paymentAlert_waitlisted:
    'Booking is waitlisted. {amount} is expected if confirmed. Consider securing the slot with an advance.',
  bookingDetail_paymentAlert_waitlisted_past:
    'Waitlisted — this event date has passed. {amount} was on the booking — review status and settlement.',
  bookingDetail_paymentAlert_tentative:
    'Tentative booking. {amount} pending — collect advance to confirm and secure the venue.',
  bookingDetail_paymentAlert_tentative_with_release:
    'This tentative booking will be automatically released on {date} if not confirmed. {amount} is pending — collect the advance before then to confirm and secure the venue.',
  bookingDetail_paymentAlert_tentative_past:
    'Tentative — event date has passed. {amount} was involved — confirm closure, payment, or release the hold.',
  bookingDetail_paymentAlert_tentative_past_release:
    'This tentative booking was due for automatic release on {date}. {amount} is pending — collect the advance now to confirm and secure the venue.',
  bookingDetail_holdDaysAlert_future:
    'This tentative booking will be automatically released on {date} if the advance is not received.',
  bookingDetail_holdDaysAlert_past:
    'This tentative booking was due for automatic release on {date}. Please confirm or release the hold.',
  bookingDetail_paymentAlert_confirmed:
    '{amount} pending for a confirmed booking. Follow up to avoid last-minute risk.',
  bookingDetail_paymentAlert_confirmed_past:
    'Event date has passed. {amount} still outstanding — prioritize collection and closure.',
  bookingDetail_paymentAlert_confirmed_noPaid: 'No payment received. {amount} pending — collect advance to proceed.',
  bookingDetail_paymentAlert_confirmed_noPaid_past:
    'Event date has passed — no payment recorded. {amount} still pending — collect urgently.',
  bookingDetail_paymentAlert_confirmed_partial: '{paid} received. {amount} still due — follow up for balance.',
  bookingDetail_paymentAlert_confirmed_partial_past:
    '{paid} received — event has passed. {amount} still due — collect the balance.',
  bookingDetail_paymentAlert_confirmed_nearly: 'Nearly settled. {amount} pending — close before event.',
  bookingDetail_paymentAlert_confirmed_nearly_past:
    'Event has passed — nearly settled. {amount} still pending — close out now.',
  bookingDetail_paymentAlert_actualized: 'Event completed. {amount} outstanding — prioritize final settlement.',
  bookingDetail_paymentAlert_cancelled: 'Booking cancelled. Review {amount} for pending dues or applicable refunds.',
  bookingDetail_paymentAlert_cancellationRequested:
    'Cancellation requested. {amount} involved — verify refund or dues before proceeding.',
  bookingDetail_paymentAlert_enquiry: 'Enquiry stage. {amount} estimated — share proposal to move forward.',
  bookingDetail_paymentAlert_enquiry_past:
    'Enquiry — event date has passed. {amount} was estimated — follow up to close or rebook.',
  bookingDetail_paymentAlert_default: 'Payment attention needed: {amount} outstanding — follow up with the customer.',
  bookingDetail_sendPaymentReminder: 'Send Payment Reminder',
  bookingDetail_paymentReminderSubject: 'Payment reminder — booking',
  bookingDetail_paymentReminderBody:
    'A balance of {0} is outstanding for booking {1}. Please arrange payment at your earliest convenience.',
  bookingDetails_text_confirmation_By: 'Booking Confirmation By',
  bookingDetails_text_gst: 'GST Amount',
  bookingDetails_text_surcharge: 'Surcharge',
  bookingDetails_text_guestCharges: 'Guest Charges',
  bookingDetails_text_hallRental: 'Hall Rental',
  bookingDetails_text_totalRental: 'Total Rental',
  edit_booking_Override_total_rental: 'Override Total Rental',
  bookingDetails_text_additional_comment: 'Additional Comment',
  bookingDetails_text_booking_creation_comment: 'Booking Creation Note',
  bookingDetails_creation_note_updated: 'Booking creation note updated',
  bookingDetails_creation_note_update_failed: 'Failed to update booking creation note',
  newbooking_max_guest_info_text: 'Please refer to the layouts below for the maximum guest count',
  layout_dropdown_max_capacity: 'Max capacity: {0}',
  dropdown_max_capacity: 'Max: {0}',
  dropdown_layout_capacity: 'min:{0} | max: {1}',
  dropdown_price_per_person: 'Price/person: {0}',
  layout_max_guests_validation: '{0} cannot accommodate more than {1} guests',
  venue_max_guests_validation: 'Venue ({0}) cannot accommodate more than {1} guests',
  bookingDetails_text_pricePerPerson: 'Price Per Person',
  bookingDetails_text_rooms: 'Rooms',
  bookingDetails_text_status: 'Booking Status',
  bookingDetails_text_total: 'Total Booking Amount',
  bookingDetails_text_days_total: 'Total amount for this date',
  bookingDetails_text_totalAddOnCost: 'Total Add-on Cost',
  bookingDetails_text_totalRoomCost: 'Total Room Cost',
  bookingDetails_text_totalRoomServiceCharge: 'Total Room Service Charges',
  bookingDetails_text_totalRoomSurcharge: 'Total Room Surcharge',
  bookingDetails_text_totalRoomTax: 'Total GST on Room',
  bookingDetails_text_totalServiceCharges: 'Service Charge',
  bookingDetails_text_taxesAndServiceCharges: 'Taxes & Service Charges:',
  bookingDetails_text_addOn_name: 'Name',
  bookingDetails_text_addOn_type: 'Type',
  bookingDetails_text_addOn_quantity: 'Quantity',
  bookingDetails_text_addOn_price: 'Price',
  bookingDetails_section_bookingInformation: 'Booking Information',
  bookingDetails_section_bookingInfoCompact: 'Booking Info',
  bookingDetails_compact_status: 'Status',
  bookingDetails_compact_reference: 'Reference',
  bookingDetails_compact_confirmedBy: 'Confirmed By',
  bookingDetails_section_pricingSummary: 'Pricing Summary',
  bookingDetails_section_invoiceCharges: 'Charges',
  bookingDetails_section_billingBreakdown: 'Billing breakdown',
  bookingDetails_billing_costingLoadError: 'Could not load billing breakdown.',
  bookingDetails_billing_loading: 'Loading breakdown…',
  bookingDetails_billing_perGuestEffectivePrice: 'Per Guest Effective Price',
  bookingDetails_invoice_baseCharges: 'Base Charges',
  bookingDetails_invoice_subtotal: 'Subtotal',
  bookingDetails_invoice_totalUpper: 'TOTAL',
  bookingDetails_billing_totalAmountLine: 'TOTAL AMOUNT',
  bookingDetails_invoice_guests: 'Guests',
  bookingDetails_section_paymentHistory: 'Payment history',
  bookingDetails_paymentHistory_empty: 'No payment records for this line item yet.',
  bookingDetails_paymentHistory_loading: 'Loading payments…',
  bookingDetails_section_addOnsDetail: 'Add-ons',
  bookingDetails_addons_group_other: 'Other',
  bookingDetails_addons_itemCount: '{count} item(s)',
  bookingDetails_column_item: 'Item',
  bookingDetails_column_pricingType: 'Pricing Type',
  bookingDetails_column_qty: 'Qty',
  bookingDetails_column_rate: 'Rate',
  bookingDetails_column_amount: 'Amount',
  bookingDetails_pricingType_perQuantity: 'Per Quantity',
  bookingDetails_pricingType_perGuest: 'Per Guest',
  bookingDetails_billing_pricePerPerson: 'Price/person',
  bookingDetails_billing_pricePerHour: 'Price/hour',
  bookingDetails_billing_addons: 'Add-ons',
  bookingDetails_billing_gstShort: 'GST',
  bookingDetails_billing_serviceCharge: 'Service Charge',
  bookingDetails_backToDiary: 'Back to diary',
  bookingDetails_moreActions: 'More',
  bookingDetails_previewSectionTitle: 'Preview',
  bookingDetails_downloadSectionTitle: 'Download',
  bookingDetail_section_eventSummary: 'Event Summary',
  bookingDetail_section_customerSummary: 'Customer Summary',
  bookingDetail_section_bookingNotes: 'Booking notes',
  bookingDetails_text_addOn_max_count: 'Max Count',
  bookingDetails_text_room_type: 'Room Type',
  bookingDetails_text_room_startDate: 'Start date',
  bookingDetails_text_room_endDate: 'End date',
  bookingDetails_text_room_noOfRoom: 'No. of rooms',
  bookingMessage_column_type: 'Booking Message Type',
  bookingMessage_column_text: 'Booking Message',
  bookingMessage_title_list: 'Booking Message List',
  bookingMessage_list_subtitle: 'Used to show booking status and guest-facing messages in the booking flow.',
  attachContract: 'Include contract',
  attachPI: 'Include proforma invoice',
  attachProposal: 'Include proposal',
  attachEnquiry: 'Include enquiry details',
  markComplementary: 'Mark this booking complementary.',
  new_booking_complementary_info:
    'Complimentary bookings are provided at no charge. Pricing, payment, and invoicing rules may differ from standard bookings.',
  new_booking_proceed_room_booking: 'Proceed to room booking',
  new_booking_proceed_room_booking_info:
    'Adds a Rooms step so you can attach accommodation and room-night charges to this booking.',
  new_booking_customer_type_label: 'Customer type',
  new_booking_customer_type_info:
    'Company: book for a corporate account with branches and contacts. Individual: book for a personal customer.',
  resetCaptcha: 'Reset Captcha',
  upload_required_error_message: 'Document is required',
  customerDetails_text_address: 'Address',
  customerDetails_text_city: 'City',
  customerDetails_text_country: 'Country',
  customerDetails_text_name: 'Customer Name',
  customerDetails_text_pinCode: 'Postal Code',
  customerDetails_text_state: 'State',
  customerDetails_title_email: 'Email',
  customerDetails_title_phone: 'Phone No',
  customermgmt_button_add: 'New Customer',
  customermgmt_button_export: 'Export',
  booking_diary_chip_title_place: 'Venue',
  booking_diary_chip_title_event: 'Event',
  booking_diary_chip_title_company: 'Company',
  booking_diary_chip_title_toggle_aria: 'Choose text shown on calendar event chips',
  booking_diary_chip_title_toggle_tooltip: 'Venue: place or venue name. Company: company or customer name.',
  booking_diary_chip_title_toggle_tooltip_timeline: 'Event: event type and subtype. Company: company or customer name.',
  booking_diary_export_reports: 'Export Reports',
  booking_diary_export_reports_tooltip: 'Export booking reports',
  booking_diary_alif_export_rv: 'ALIF Export RV',
  booking_diary_alif_export_cl: 'ALIF Export CL',
  booking_diary_select_date: 'Select Date',
  booking_diary_export_button: 'Export',
  booking_diary_export_summary_month: 'Export summary for month',
  booking_diary_export_booking_for_date: 'Export booking for given date',
  booking_diary_search_placeholder: 'Search by customer, company, booking ref, or venue',
  booking_diary_toggle_cancelled_expired: 'Cancelled / Expired',
  calendar_legend_booking_status: 'Booking Status',
  calendar_legend_availability: 'Availability',
  calendar_legend_booking_types: 'Booking Indicators',
  calendar_legend_flag_corporate: 'Corporate',
  customermgmt_column_action: 'Action',
  customermgmt_column_email: 'Email',
  customermgmt_column_role: 'Role',
  customermgmt_column_registration_date: 'Registration Date',
  customermgmt_list_title: 'Customer List',
  customermgmt_text_address: 'Address',
  customermgmt_text_city: 'City',
  customermgmt_text_company: 'Company Name',
  customermgmt_text_country: 'Country',
  customermgmt_text_designation: 'Designation',
  customermgmt_text_firstName: 'First Name',
  customermgmt_text_gst: 'GSTIN',
  customermgmt_text_panNumber: 'PAN Number',
  customermgmt_text_lastName: 'Last Name',
  customermgmt_text_phone: 'Phone No',
  customermgmt_loyalty_number: 'Loyalty referance',
  customermgmt_text_pinCode: 'Postal Code',
  customermgmt_text_state: 'State',
  customermgmt_title_add: 'Add Customer',
  customermgmt_title_edit: 'Edit Customer',
  customermgmt_text_individual: 'Individual',
  customermgmt_text_individual_name: 'Individual Name',
  customermgmt_text_Company: 'Company',
  dashboard_title_text: 'Dashboard',
  dashboard_trends_custom: 'Custom',
  dashboard_trends_apply_range: 'Apply range',
  dashboard_trends_range_invalid: 'End date must be on or after start date.',
  dashboard_trends_range_too_long: 'Choose at most 365 days.',
  segment_button_add: 'New Segment',
  segment_title_add: 'Add Segment',
  segment_title_edit: 'Edit Segment',
  segment_title_list: 'Event Segments',
  segment_list_subtitle: 'Used when creating bookings, venue configurations, reports, and booking filters.',
  import_booking_text_menu: 'Import Bookings',
  import_booking_title: 'Import Booking',
  import_success: 'Data imported successfully',
  layout_button_add: 'Add Layout',
  layout_column_name: 'Name',
  layout_text_name: 'Name',
  layout_title_add: 'Add Layout',
  layout_title_edit: 'Edit Layout',
  layout_title_list: 'Layouts',
  layout_list_subtitle: 'Used when configuring venues and selecting seating layouts on bookings.',
  mailTemplate_column_type: 'Mail Template Type',
  mailTemplate_text_subject: 'Subject',
  mailTemplate_text_content: 'Mail Template Content',
  mailTemplate_title_edit: 'Update Mail Template',
  mailTemplate_title_list: 'Mail Template List',
  mailTemplate_list_subtitle: 'Used when sending transactional emails for bookings and system events.',
  menu_text_users: 'Users',
  menu_text_bookings_diary: 'Bookings Diary',
  menu_text_bookings: 'Bookings',
  menu_text_dashboard: 'Dashboard',
  menu_text_segment: 'Event Segments',
  menu_text_layout: 'Layouts',
  menu_text_mailTemplate: 'Email Templates',
  menu_text_master_data: 'Master Data',
  menu_text_org: 'Venue & Room Configurations',
  menu_text_organization: 'Organizations',
  menu_text_parentOrg: 'Parent Organization',
  menu_text_pricePackage: 'Price Packages',
  menu_text_reports: 'Reports & Analytics',
  menu_text_standard_reports: 'Reports',
  menu_text_consolidated_reports: 'Consolidated Reports',
  menu_text_room: 'Rooms',
  menu_text_roomType: 'Room Types',
  menu_text_systemMessage: 'System Messages',
  menu_text_taxCode: 'Tax Codes',
  menu_text_taxGroup: 'Tax Groups',
  menu_text_surcharge: 'Surcharges',
  menu_text_templateSchedule: 'Template Schedules',
  menu_text_timeSlot: 'Time Slots',
  menu_text_user_management: 'User Management',
  menu_text_venue: 'Venues',
  menu_text_venueType: 'Venue Types',
  menu_text_bookingList: 'Booking List',
  menu_text_booking_event_source: 'Event & Source Updates',
  booking_event_source_subtitle: 'Review and update event segment and source details for bookings.',
  menu_text_deletedBookings: 'Deleted Bookings',
  menu_text_booking_enquiries: 'Booking Enquiries',
  menu_sa_booking_lookup: 'Booking lookup',
  menu_property_onboarding: 'Property Onboarding',
  menu_property_readiness: 'Property Readiness Dashboard',
  menu_opera_logs: 'Opera Logs',
  property_readiness_title: 'Property Readiness Dashboard',
  property_readiness_description:
    'Review setup completeness, document templates, and venue configuration coverage before accepting bookings.',
  property_readiness_onboarding_heading: 'Onboarding: {property}',
  property_readiness_onboarding_subtitle: 'Complete the setup to start receiving bookings',
  property_readiness_onboarding_progress: 'Onboarding Progress',
  property_readiness_completed: 'Completed',
  property_readiness_view_setup_guide: 'View Setup Guide',
  property_readiness_manage_templates: 'Manage Templates',
  property_readiness_view_details: 'View Details',
  property_readiness_tip_label: 'Tip:',
  property_readiness_bulk_tip: 'You can bulk create missing configurations for multiple venues at once.',
  property_readiness_learn_how: 'Learn how',
  property_readiness_section_readiness: 'Property Readiness',
  property_readiness_venue_setup: 'Venue Setup',
  property_readiness_price_packages: 'Price Packages',
  property_readiness_venue_configurations: 'Venue Configurations',
  property_readiness_addons: 'Add-ons',
  property_readiness_section_templates: 'Document Templates',
  property_readiness_template_contract: 'Contract template',
  property_readiness_template_proposal: 'Proposal template',
  property_readiness_template_pi: 'PI template',
  property_readiness_template_beo: 'BEO template',
  property_readiness_template_invoice: 'Invoice template',
  property_readiness_template_uploaded: 'Uploaded',
  property_readiness_template_missing: 'Not uploaded',
  property_readiness_section_booking_status: 'Booking Ready Status',
  property_readiness_booking_ready:
    'This property is ready to accept bookings. Venues, packages, templates, and venue configurations are in place.',
  property_readiness_booking_not_ready:
    'This property is not ready for bookings yet. Complete the missing setup items below.',
  property_readiness_booking_ready_short: 'This property is ready for bookings.',
  property_readiness_booking_ready_detail: 'All required setup items are complete.',
  property_readiness_booking_not_ready_short: 'This property is not ready for bookings yet.',
  property_readiness_booking_not_ready_detail: 'Complete the missing setup items below.',
  property_readiness_section_missing_configs: 'Missing Venue Configurations',
  property_readiness_no_missing_configs: 'Every venue has a configuration for each event type.',
  property_readiness_missing_configs_count: '{count} missing configuration(s) detected.',
  property_readiness_missing_configs_hint: 'Complete the missing items to make your venues bookable.',
  property_readiness_all_configs_present: 'All venue and event type combinations are configured.',
  property_readiness_venue_label: 'Venue: {venue}',
  property_readiness_events_configured: 'Configured event types',
  property_readiness_events_missing: 'Missing configurations',
  property_readiness_venue_image_not_uploaded: 'Not uploaded',
  property_readiness_create_missing_configs: 'Create Missing Configs',
  property_readiness_create_missing_success: 'Created {created}, skipped {skipped}, failed {failed}.',
  property_readiness_create_missing_error: 'Unable to create missing configurations. Please try again.',
  property_readiness_load_error: 'Unable to load property readiness dashboard. Please try again.',
  property_onboarding_title: 'Property Onboarding',
  property_onboarding_description:
    'Set up core property data by importing templates or creating records manually. Progress is weighted by section importance.',
  property_onboarding_property_label: 'Property name',
  property_onboarding_progress_label: 'Onboarding progress: {percent}%',
  property_onboarding_progress_hint:
    'Event types and venues carry the highest weight, price packages are mandatory with moderate weight, and add-ons and seating styles carry the least weight.',
  property_onboarding_event_types: 'Event Types',
  property_onboarding_venues: 'Venues',
  property_onboarding_packages: 'Packages',
  property_onboarding_addons: 'Add-ons',
  property_onboarding_seating_styles: 'Seating Styles',
  property_onboarding_venue_configurations: 'Venue Configurations',
  property_onboarding_item_column: 'Item',
  property_onboarding_records_column: 'Records in database',
  property_onboarding_status_column: 'Status',
  property_onboarding_actions_column: 'Actions',
  property_onboarding_upload_template: 'Upload template',
  property_onboarding_create: 'Create',
  property_onboarding_bulk_create: 'Bulk create venue configurations',
  property_onboarding_view_records: 'View records',
  property_onboarding_records_drawer_title: '{item} records',
  property_onboarding_records_drawer_empty: 'No records found.',
  property_onboarding_records_count: '{count} record(s)',
  property_onboarding_records_showing: 'Showing {shown} of {total} records',
  property_onboarding_records_load_error: 'Unable to load records. Please try again.',
  property_onboarding_addon_import_title: 'Import Add-ons',
  property_onboarding_addon_import_file: 'File: {file}',
  property_onboarding_addon_validation_step: 'Validation',
  property_onboarding_addon_validating: 'Validating spreadsheet…',
  property_onboarding_addon_check_file: 'Valid Excel file',
  property_onboarding_addon_check_sheet: 'Valid sheet with data',
  property_onboarding_addon_check_headers: 'Valid headers',
  property_onboarding_addon_valid_count: '{count} valid',
  property_onboarding_addon_error_count: '{count} error',
  property_onboarding_addon_error_grid_title: 'Errors',
  property_onboarding_addon_error_row: 'Row',
  property_onboarding_addon_error_message: 'Error',
  property_onboarding_addon_error_grid_empty: 'No row errors',
  property_onboarding_addon_preview_title: 'What will be created',
  property_onboarding_addon_preview_empty: 'All add-ons in this file already exist. Nothing new to import.',
  property_onboarding_addon_preview_total: 'Total: {count}',
  property_onboarding_addon_import_confirm: 'Import',
  property_onboarding_addon_importing: 'Importing…',
  property_onboarding_addon_validate_error: 'Unable to validate file. Please try again.',
  property_onboarding_complete: 'Complete',
  property_onboarding_incomplete: 'Incomplete',
  property_onboarding_venue_config_disabled:
    'Add at least one event type, venue, and price package before configuring venues.',
  property_onboarding_coming_soon: 'Import template for this item is not available yet.',
  property_onboarding_load_error: 'Unable to load record counts. Please try again.',
  property_onboarding_download_error: 'Unable to download template. Please try again.',
  property_onboarding_upload_error: 'Unable to upload template. Please try again.',
  property_onboarding_import_title: 'Import {item}',
  property_onboarding_import_common_info: 'These are shared across all properties. Importing here adds them globally.',
  property_onboarding_import_preview_empty_event_types:
    'All event types in this file already exist. Nothing new to import.',
  property_onboarding_import_preview_empty_venues: 'All venues in this file already exist. Nothing new to import.',
  property_onboarding_import_preview_empty_packages:
    'All price packages in this file already exist. Nothing new to import.',
  property_onboarding_import_preview_empty_layouts:
    'All seating styles in this file already exist. Nothing new to import.',
  property_onboarding_footer_note: 'Venue configurations use bulk create only.',
  sa_booking_lookup_title: 'Booking lookup',
  sa_booking_lookup_description:
    'Search by booking or order reference to view full booking data. Read-only; for BBR administrators.',
  sa_booking_lookup_order_ref: 'Booking or order reference',
  sa_booking_lookup_search: 'Load booking',
  sa_booking_lookup_empty_ref: 'Enter a booking or order reference.',
  sa_booking_lookup_booking_section: 'Booking details',
  sa_booking_lookup_payments_section: 'Payment records',
  sa_booking_lookup_line_items_section: 'Line items (events & packages)',
  sa_booking_lookup_li_card_title: 'Line item',
  sa_booking_lookup_li_event_date: 'Event dates',
  sa_booking_lookup_li_event_time: 'Event time',
  sa_booking_lookup_li_pax: 'Guests (pax)',
  sa_booking_lookup_li_guaranteed_abbr: 'Guaranteed',
  sa_booking_lookup_li_expected_abbr: 'Expected',
  sa_booking_lookup_li_edit: 'Edit line item',
  sa_booking_lookup_li_delete: 'Remove line item',
  sa_booking_lookup_li_restore: 'Restore line item',
  sa_booking_lookup_li_delete_dialog_title: 'Remove line item?',
  sa_booking_lookup_li_delete_dialog_body:
    'This soft-deletes the line item so it is hidden from normal booking views. You can restore it from this screen later.',
  sa_booking_lookup_li_delete_cancel: 'Cancel',
  sa_booking_lookup_li_delete_confirm: 'Remove',
  sa_booking_lookup_li_deleted_ok: 'Line item removed.',
  sa_booking_lookup_li_restored_ok: 'Line item restored.',
  sa_booking_lookup_li_mutation_error: 'Could not update the line item. Try again.',
  sa_booking_lookup_li_reason_label: 'Reason for this change',
  sa_booking_lookup_li_reason_required: 'Enter a reason for this change.',
  sa_booking_lookup_li_restore_dialog_title: 'Restore line item?',
  sa_booking_lookup_li_restore_dialog_body:
    'This makes the line item visible again in normal booking views. Add a short reason for the audit trail.',

  sa_booking_li_edit_title: 'Edit booking line item',
  sa_booking_li_edit_save_reason_title: 'Save line item',
  sa_booking_li_edit_save_reason_body:
    'Describe why you are saving these changes. This is recorded in line item update history.',
  sa_booking_li_edit_update_reason_required: 'Enter an update reason before saving.',
  sa_booking_li_edit_back: 'Back to lookup',
  sa_booking_li_edit_back_lookup: 'Back to booking lookup',
  sa_booking_li_edit_saved: 'Line item saved.',
  sa_booking_li_edit_section_schedule: 'Schedule & packages',
  sa_booking_li_edit_section_venue_schedule_guests: 'Venue, event, schedule & guest counts',
  sa_booking_li_edit_section_guests: 'Guest counts',
  sa_booking_li_edit_section_pricing: 'Pricing & charges',
  sa_booking_li_edit_pricing_auto_helper:
    'Turn on the override switch to type a value. Otherwise the amount is calculated from the venue and package when you save.',
  sa_booking_li_edit_section_addons: 'Add-ons',
  sa_booking_li_edit_section_status: 'Status & assignment',
  sa_booking_li_edit_section_pms: 'PMS / interface',
  sa_booking_li_edit_hint_minutes: 'Minutes',
  sa_booking_li_edit_err_venue_id: 'Enter a valid venue ID.',
  sa_booking_li_edit_err_numbers: 'Enter valid numbers for lead times and guest counts.',
  sa_booking_li_edit_err_service_charge: 'Enter a valid service charge.',
  sa_booking_li_edit_err_addons: 'Fix add-on rows: each line needs a selected add-on and a valid quantity.',
  sa_booking_li_edit_addons_none:
    'No add-ons are available for this line item (master data could not be loaded or the venue has none).',
  sa_booking_li_edit_err_missing_route: 'Missing booking reference or line item in the URL.',
  sa_booking_li_edit_err_load: 'Could not load booking or line item.',
  sa_booking_li_edit_err_not_found: 'This line item was not found on the booking.',
  sa_booking_li_edit_err_validation: 'Please fix validation errors and try again.',
  sa_booking_li_edit_err_save: 'Could not save line item.',
  sa_booking_li_edit_unknown_venue: 'Venue',
  sa_booking_li_edit_seating_style: 'Seating style',
  sa_booking_li_edit_service_charge_pct: 'Service charge (%)',
  sa_booking_li_edit_pricing_card_hourly: 'Hourly rate',
  sa_booking_li_edit_pricing_card_hall: 'Hall rental',
  sa_booking_li_edit_pricing_card_minimum: 'Minimum revenue',
  sa_booking_li_edit_pricing_card_ppp: 'Price per person',
  sa_booking_lookup_audit_section: 'Audit trail',
  sa_booking_lookup_section_guest_company: 'Guest details',
  sa_booking_lookup_section_booking_org_notes: 'Booking details',
  sa_booking_lookup_section_payment_terms: 'Payment configs',
  sa_booking_lookup_section_other: 'Additional attributes',
  sa_booking_lookup_save: 'Save',
  sa_booking_lookup_save_not_ready: 'Saving changes for this section is not available yet.',
  sa_booking_lookup_guest_saved: 'Guest details saved.',
  sa_booking_lookup_booking_details_saved: 'Booking details saved.',
  sa_booking_lookup_payment_config_saved: 'Payment configuration saved.',
  sa_booking_lookup_payment_percent_sum: 'Minimum confirmation plus instalment 1, 2, and 3 (%) must add up to 100.',
  sa_booking_lookup_payment_percent_total: 'Total: {n}% (must equal 100%)',
  sa_booking_lookup_corporate_sales_required: 'Select a sales account and branch for corporate bookings.',
  sa_booking_lookup_event_type_required: 'Select an event type.',
  sa_booking_lookup_sales_account: 'Sales account',
  sa_booking_lookup_sales_branch: 'Sales branch',
  sa_booking_lookup_geo_none: '— None —',
  sa_booking_lookup_geo_incomplete: 'When a country is selected, choose both state and city.',

  // Super admin booking lookup — field labels (match API camelCase keys)
  sa_booking_lbl_id: 'ID',
  sa_booking_lbl_createdAt: 'Created at',
  sa_booking_lbl_deleted: 'Deleted',
  sa_booking_lbl_editedAt: 'Last edited at',
  sa_booking_lbl_editedBy: 'Last edited by',
  sa_booking_lbl_createdBy: 'Created by',
  sa_booking_lbl_tenantId: 'Tenant ID',
  sa_booking_lbl_customerFirstName: 'First name',
  sa_booking_lbl_customerLastName: 'Last name',
  sa_booking_lbl_email: 'Email',
  sa_booking_lbl_countryCode: 'Country code',
  sa_booking_lbl_phoneNumber: 'Phone number',
  sa_booking_lbl_company: 'Is company (not individual)',
  sa_booking_lbl_companyName: 'Company name',
  sa_booking_lbl_designation: 'Designation',
  sa_booking_lbl_gst: 'GST / tax ID',
  sa_booking_lbl_address: 'Address',
  sa_booking_lbl_country: 'Country',
  sa_booking_lbl_state: 'State / region',
  sa_booking_lbl_city: 'City',
  sa_booking_lbl_pinCode: 'Postal / PIN code',
  sa_booking_lbl_language: 'Language',
  sa_booking_lbl_salesAccountId: 'Sales account ID',
  sa_booking_lbl_salesBranchId: 'Sales branch ID',
  sa_booking_lbl_bookingReference: 'Booking reference',
  sa_booking_lbl_bookingDate: 'Booking date',
  sa_booking_lbl_startDate: 'Start date',
  sa_booking_lbl_endDate: 'End date',
  sa_booking_lbl_eventTypeId: 'Event type',
  sa_booking_lbl_bookingConfirmationBy: 'Confirmed by',
  sa_booking_lbl_bookingStatus: 'Booking status',
  sa_booking_lbl_holdDays: 'Hold period (days)',
  sa_booking_lbl_organizationId: 'Organization ID',
  sa_booking_lbl_referredBy: 'Referred by',
  sa_booking_lbl_revenueOwnerUserIds: 'Revenue owner user IDs',
  sa_booking_lbl_userId: 'User ID',
  sa_booking_lbl_minConfirmPaymentPercentage: 'Minimum confirmation payment (%)',
  sa_booking_lbl_paymentSlotOnePercentage: 'Payment instalment 1 (%)',
  sa_booking_lbl_paymentSlotTwoPercentage: 'Payment instalment 2 (%)',
  sa_booking_lbl_paymentSlotThreePercentage: 'Payment instalment 3 (%)',
  sa_booking_lbl_paymentSlotOneBeforeDays: 'Instalment 1 due (days before)',
  sa_booking_lbl_paymentSlotTwoBeforeDays: 'Instalment 2 due (days before)',
  sa_booking_lbl_fullPaymentBeforeDays: 'Full payment due (days before)',
  sa_booking_lbl_paymentStatus: 'Payment status',
  sa_booking_lbl_paymentOverDueText: 'Payment overdue message',
  sa_booking_lbl_additionalComments: 'Additional comments',
  sa_booking_lbl_requestedChanges: 'Requested changes',
  sa_booking_lbl_cancelReason: 'Cancellation reason',
  sa_booking_lbl_customerBooking: 'Customer self-booking',
  sa_booking_lbl_isGuestBooking: 'Placed via guest checkout (no customer login)',
  sa_booking_lbl_isCorporateBooking: 'Corporate booking',
  sa_booking_lbl_isComplementary: 'Complimentary',
  sa_booking_lbl_externalBooking: 'External booking',
  sa_booking_lbl_agentId: 'Agent ID',
  sa_booking_lbl_payments: 'Payments',

  sa_booking_lbl_name: 'Name',
  sa_booking_lbl_phoneNo: 'Phone number',
  sa_booking_lbl_amountPaid: 'Amount paid',
  sa_booking_lbl_paymentDate: 'Payment date',
  sa_booking_lbl_paymentLocation: 'Payment location',
  sa_booking_lbl_paymentMethod: 'Payment method',
  sa_booking_lbl_paymentReference: 'Payment reference',
  sa_booking_lbl_docNo: 'Document number',
  sa_booking_lbl_isTdsDeducted: 'TDS deducted',
  sa_booking_lbl_attachmentType: 'Attachment type',
  sa_booking_lbl_roomNumber: 'Room number',
  sa_booking_lbl_roomReservationId: 'Room reservation ID',
  sa_booking_lbl_roomReservationName: 'Room reservation name',
  sa_booking_lbl_isRoomPayment: 'Room payment',
  sa_booking_lbl_bookingLineItemId: 'Booking line item ID',

  sa_booking_lbl_bookingId: 'Booking ID',
  sa_booking_lbl_venueId: 'Venue ID',
  sa_booking_lbl_venueName: 'Venue',
  sa_booking_lbl_eventSubtype: 'Event subtype',
  sa_booking_lbl_placeOfEvent: 'Place of event',
  sa_booking_lbl_addressOfEvent: 'Event address',
  sa_booking_lbl_startTime: 'Start time',
  sa_booking_lbl_endTime: 'End time',
  sa_booking_lbl_preLeadTime: 'Pre-lead time (minutes)',
  sa_booking_lbl_postLeadTime: 'Post-lead time (minutes)',
  sa_booking_lbl_partOfDay: 'Part of day',
  sa_booking_lbl_guaranteedGuests: 'Guaranteed guests',
  sa_booking_lbl_expectedGuests: 'Expected guests',
  sa_booking_lbl_serviceChargeId: 'Service charge ID',
  sa_booking_lbl_serviceCharge: 'Service charge',
  sa_booking_lbl_hallRental: 'Hall rental',
  sa_booking_lbl_overrideHallRental: 'Override hall rental',
  sa_booking_lbl_pricePerPerson: 'Price per person',
  sa_booking_lbl_overridePricePerPerson: 'Override price per person',
  sa_booking_lbl_minimumRevenue: 'Minimum revenue',
  sa_booking_lbl_overrideMinimumRevenue: 'Override minimum revenue',
  sa_booking_lbl_pricePerHour: 'Price per hour',
  sa_booking_lbl_overridePricePerHour: 'Override price per hour',
  sa_booking_lbl_hourlyPricing: 'Hourly pricing',
  sa_booking_lbl_assigneeId: 'Assignee ID',
  sa_booking_lbl_layoutId: 'Layout ID',
  sa_booking_lbl_splitRevenuePercent: 'Revenue split (%)',
  sa_booking_lbl_status: 'Status',
  sa_booking_lbl_pricePackageId: 'Price package ID',
  sa_booking_lbl_timeSlotId: 'Time slot ID',
  sa_booking_lbl_pmsStatus: 'PMS status',
  sa_booking_lbl_pmsBookingNumber: 'PMS booking number',
  sa_booking_lbl_pmsBookingSerial: 'PMS booking serial',

  menu_text_venueconfig: 'Venue Configurations',
  menu_text_rfq: 'Request for Quotes',
  menu_title_booking_msg: 'Booking Messages',
  menu_title_location: 'Locations',
  menu_text_budget: 'Budgets',
  menu_text_Sources: 'Sources',
  menu_text_customers: 'Customers',
  organization_text_add_org: 'Add Organization',
  organization_text_edit_org: 'Edit Organization',
  organization_text_contact_name: 'Contact Name',
  organization_section1: 'Organization Info',
  organization_section2: 'Location Info',
  organization_section3: 'Payment Info',
  organization_section4: 'Booking Info',
  organization_section5: 'Media Info',
  organization_section6: 'Currency Info',
  organization_text_show_alternate_days: 'Show alternate days',
  organization_text_alternativeDateInterval: 'Alternative Date Interval',
  organization_showRFQForExceedingBookingWindowTimeFrame: 'Show RFQ for exceeding booking Window time frame',
  organization_show_booking_window_time_frame: 'Booking window time frame',
  bookings_button_preview: 'Preview',
  bookings_button_preview_contract: 'Preview Contract',
  bookings_button_download_contract: 'Download Contract',
  bookings_button_preview_proposal: 'Preview Proposal',
  bookings_button_download_proposal: 'Download Proposal',
  bookings_button_preview_pi: 'Preview PI',
  bookings_button_download_pi: 'Download PI',
  bookings_button_preview_enquiry: 'Preview Enquiry',
  bookings_button_download_enquiry: 'Download Enquiry',
  bookings_button_share: 'Share',
  bookings_button_share_email: 'Email',
  bookings_button_share_whatsapp: 'WhatsApp',
  bookings_button_share_attach_hint: 'The PDF has been downloaded. Please attach it to your message.',

  bookings_button_calcuate_bill: 'View charges summary',
  contract: 'Contract',
  proposal: 'Proposal',
  pi: 'PI',
  enquiry: 'Enquiry Details',
  download_contract_proposal_pi: 'Download contract/proposal/PI',
  editEventDetailErrorMsg:
    'This event is already selected. Please Click on the pencil icon in the previous table to update the details of this event.',
  organization_text_holdDays: 'Hold Days',
  organization_text_logo: 'Organization Logo',
  organization_text_address: 'Address',
  organization_text_confirmationBy: 'Booking Confirmation By',
  organization_text_contractTemplate: 'Contract Template',
  organization_text_beoTemplate: 'BEO Template',
  organization_text_invoiceTemplate: 'Invoice Template',
  organization_text_menuPlan: 'Food & Beverage/Audio Visual Selection',
  organization_text_proposalTemplate: 'Proposal Template',
  organization_text_piTemplate: 'PI Template',
  organization_text_corporateRateTemplate: 'Corporate Rate Template',
  organization_text_enquiry_template: 'Enquiry Template',
  organization_text_description: 'Description',
  organization_text_rfqTerms: 'Rfq Terms',
  roomReservationText: 'Room reservation text',
  venue_text_parentVenueId: 'Parent Venue',
  organization_text_email: 'Email',
  organization_text_gst: 'GSTIN',
  organization_text_pinCode: 'Pincode',
  organization_text_orderPrefix: 'Order Prefix',
  organization_text_orderPrefix_placeholder: '3 letters or numbers, e.g. ORD',
  organization_order_prefix_invalid: 'Order prefix must be exactly 3 alphanumeric characters',
  organization_text_image: 'Image',
  organization_text_latitude: 'Latitude',
  organization_text_longitude: 'Longitude',
  organization_text_placeId: 'PlaceId',
  organization_text_minConfirmPercent: 'Min. Confirm Payment %',
  organization_text_name: 'Name',
  organization_text_currency_locale: 'Currency Locale',
  organization_text_default_country_code: 'Default Country Code',
  organization_text_phone: 'Phone',
  organization_text_roomsAvailable: 'Room Available',
  organization_text_serviceChargePercent: 'Service Charge %',
  organization_text_slotOneBeforeDays: 'Payment Slot One Before Days',
  organization_text_slotOnePercent: 'Payment Slot One %',
  organization_text_slotThreeBeforeDays: 'Full Payment Before Days',
  organization_text_slotThreePercent: 'Payment Slot Three %',
  organization_text_slotTwoBeforeDays: 'Payment Slot Two Before Days',
  organization_text_slotTwoPercent: 'Payment Slot Two %',
  organization_text_streetViewExp: 'Virtual Tour URL',
  organization_title_list: 'Organization',
  parentOrg_column_add: 'Add Organization',
  parentOrg_column_name: 'Name',
  parentOrg_text_segment: 'Segment',
  parentOrg_text_layout: 'Layout',
  parentOrg_text_location: 'Location',
  parentOrg_text_logo: 'Logo',
  parentOrg_text_tab_logo: 'Tab Icon',
  parentOrg_text_venueType: 'Venue Type',
  parentOrg_title_list: 'Parent Organization',
  parentOrg_list_subtitle: 'Manage parent organizations and the segments, venues, and locations they share.',
  parentOrg_title_update: 'Update Parent Organization',
  paymentDetails_summary_title: 'Payment Summary',
  paymentDetails_summary_subtitle: 'Track collections across events and room bookings',
  paymentDetails_drawer_column_amount: 'Amount',
  paymentDetails_drawer_column_mode: 'Mode',
  paymentDetails_drawer_column_refNo: 'Ref No',
  paymentDetails_room_number: 'Room No.',
  paymentDetails_bookedRooms_title: 'Booked Rooms',
  paymentDetails_bookedRooms_subtitle: 'Multiple Room Assignments',
  paymentDetails_button_viewPayments: 'View Payments',
  paymentDetails_currentItem_label: 'Current',
  paymentDetails_collectionPercent_label: 'Collection Percent',
  paymentDetails_column_actions: 'Actions',
  paymentDetails_column_dueAmount: 'Due Amount',
  paymentDetails_column_itemLineItem: 'Item / Line Item',
  paymentDetails_column_paidAmount: 'Paid Amount',
  paymentDetails_column_status: 'Status',
  paymentDetails_column_totalAmount: 'Total Amount',
  paymentDetails_column_type: 'Type',
  paymentDetails_drawer_empty_subtitle: 'Use Add New Payment to record the first transaction for this item.',
  paymentDetails_drawer_empty_title: 'No payments yet',
  paymentDetails_drawer_title: 'Payment History',
  paymentDetails_status_paid: 'PAID',
  paymentDetails_status_partiallyPaid: 'PARTIALLY PAID',
  paymentDetails_status_pending: 'PENDING',
  paymentDetails_type_bookedRooms: 'BOOKED-ROOMS',
  paymentDetails_type_event: 'EVENT',
  paymentDetails_type_refund: 'REFUND',
  paymentDetails_text_amountDue: 'Amount Due as on Date',
  paymentDetails_text_attachment: 'Attachment',
  paymentDetails_addedBy: 'Added by',
  paymentDetails_text_date: 'Payment Date',
  paymentDetails_text_location: 'Payment Location',
  paymentDetails_text_paymentOverdue: 'Payment Overdue',
  paymentDetails_text_ycsRoomsManaged: 'Managed in YCS',
  paymentDetails_text_reference: 'Payment Reference',
  paymentDetails_text_pan_no: 'Pan No.',
  paymentDetails_text_totalPrice: 'Total Price',
  paymentDetails_title_method: 'Payment Method',
  paymentDetails_title_paid: 'Amount Paid',
  paymentDetails_title_pan_card: 'Pan No.',
  paymentDetails_deletePayment_title: 'Remove payment',
  paymentDetails_deleteRefund_title: 'Remove refund',
  paymentDetails_deletePayment_prompt: 'This payment will be excluded from collection totals.',
  paymentDetails_deleteRefund_prompt: 'This refund will be excluded from collection totals.',
  paymentDetails_deletePayment_summaryLabel: 'Transaction details',
  paymentDetails_deletePayment_reasonLabel: 'Reason for removal',
  paymentDetails_deletePayment_reasonPlaceholder: 'Describe why this payment is being removed…',
  paymentDetails_deletePayment_confirm: 'Remove payment',
  receivable_section_title: 'Ledger Entries',
  receivable_button_add: 'BTC / Ledger',
  receivable_drawer_title: 'BTC / Ledger',
  receivable_field_type: 'Type',
  receivable_field_amount: 'Amount',
  receivable_field_companyName: 'Company Name',
  receivable_field_company: 'Company',
  receivable_field_branch: 'Branch',
  receivable_field_contact: 'Contact',
  receivable_field_gstNumber: 'GST Number',
  receivable_field_creditDays: 'Credit Days',
  receivable_field_dueDate: 'Due Date',
  receivable_field_remarks: 'Remarks',
  receivable_type_billToCompany: 'Bill to Company',
  receivable_type_cityLedger: 'City Ledger',
  receivable_column_date: 'Date',
  receivable_column_type: 'Type',
  receivable_column_party: 'Party',
  receivable_column_amount: 'Amount',
  receivable_column_received: 'Received',
  receivable_column_pending: 'Pending',
  receivable_column_status: 'Status',
  receivable_status_open: 'OPEN',
  receivable_status_partiallySettled: 'PARTIALLY SETTLED',
  receivable_status_settled: 'SETTLED',
  receivable_status_cancelled: 'CANCELLED',
  receivable_empty_title: 'No receivable entries yet',
  receivable_empty_subtitle: 'Use Add Receivable to record City Ledger or Bill to Company receivables.',
  receivable_button_settle: 'Settle',
  receivable_settle_title: 'Receive Settlement',
  receivable_settle_settlementLabel: 'Settlement',
  receivable_settle_pendingAmount: 'Pending Amount',
  receivable_settle_paymentDetails: 'Payment Details',
  receivable_settle_amountReceived: 'Amount Received',
  receivable_settle_paymentMode: 'Payment Mode',
  receivable_settle_paymentDate: 'Payment Date',
  receivable_settle_referenceNo: 'Reference No.',
  receivable_settle_allocateAgainst: 'Allocate Against',
  receivable_settle_column_item: 'Item',
  receivable_settle_column_total: 'Total',
  receivable_settle_column_paid: 'Paid',
  receivable_settle_column_due: 'Due',
  receivable_settle_column_allocate: 'Allocate',
  receivable_settle_totalAllocated: 'Total Allocated',
  receivable_settle_balance: 'Balance',
  receivable_settle_save: 'Save Settlement',
  receivable_settle_allocationMismatch: 'Total allocated must equal amount received',
  receivable_settle_exceedsDue: 'Allocation cannot exceed due amount',
  receivable_settle_exceedsPending: 'Amount received cannot exceed pending amount',
  receivable_exceedsOutstanding: 'Receivable amount cannot exceed booking outstanding amount',
  receivable_maxOutstanding_hint: 'Maximum receivable allowed',
  company_master_ledger: 'Ledger',
  company_master_company_ledgers: 'Company Ledgers',
  company_master_ledger_empty: 'No records available',
  company_master_ledger_column_event: 'Event Details',
  company_master_ledger_column_customer: 'Customer',
  company_master_ledger_column_due_date: 'Due Date',
  company_master_ledger_kpi_total_amount: 'Total Amount',
  company_master_ledger_kpi_received_total: 'Received Total',
  company_master_ledger_kpi_total_due: 'Total Due',
  company_master_ledger_day_overdue: '1 day overdue',
  company_master_ledger_days_overdue: '{0} days overdue',
  receivable_button_cancel: 'Cancel',
  receivable_button_reverse: 'Reverse',
  receivable_button_manage: 'Manage',
  receivable_cancel_title: 'Cancel BTC/Ledger',
  receivable_cancel_prompt:
    'This will remove the BTC/Ledger entry. This action is only allowed when no settlement has been recorded.',
  receivable_cancel_confirm: 'Cancel BTC/Ledger',
  receivable_cancel_summaryLabel: 'BTC / Ledger',
  receivable_manage_title: 'Manage Receivable',
  receivable_manage_settlements: 'Settlement Receipts',
  receivable_manage_noActiveSettlements: 'No active settlements to reverse.',
  receivable_status_reversed: 'REVERSED',
  receivable_reverse_defaultReason: 'Settlement reversed',
  paymentDetails_deleteRefund_confirm: 'Remove refund',
  paymentDetails_drawer_column_actions: 'Actions',
  pricePackage_button_add: 'New Price Package',
  pricePackage_column_Price_order: 'Sort Order',
  pricePackage_column_hsn_code: 'HSN code',
  pricePackage_column_name: 'Package Name',
  pricePackage_text_name: 'Package Name',
  pricePackage_text_content: 'Price Package Content',
  pricePackage_text_price_order: 'Sort Order',
  pricePackage_text_hsn_code: 'HSN code',
  pricePackage_title_add: 'Add Price Package',
  pricePackage_title_edit: 'Edit Price Package',
  pricePackage_title_list: 'Price Packages',
  pricePackage_list_subtitle: 'Used in venue configurations and booking line items to define pricing packages.',
  reports_button_search: 'Search',
  reports_button_export_ang_details: 'Export A&G Details',
  reports_button_export_cover_report: 'Export Cover Report',
  reports_button_export_settlement: 'Export Settlement Report',
  reports_button_export_revenue_snapshots: 'Export Revenue Snapshots',
  reports_text_confirmed_bookings: 'Confirmed',
  reports_text_tentative_bookings: 'Tentative',
  reports_text_waitlisted_bookings: 'Waitlisted',
  reports_text_cancelled_bookings: 'Cancelled',
  reports_text_payment_due_bookings: 'Payment Dues',
  reports_text_budget: 'Budget versus BoB',
  reports_text_budget_vs_actual: 'Budget vs Actual Revenue',
  reports_text_consolidateBoB: 'Consolidated Business on the Books',
  reports_text_segmentBoB: 'Segment-wise Business on the Books',
  reports_text_timeWiseBoB: 'Time-wise Business on the Books',
  reports_text_venueBoB: 'Venue-wise Business on the Books',
  reports_text_hotelWiseBob: 'Hotel-wise Business on the Books',
  reports_text_company_BoB: 'Company-wise Business on the Books',
  reports_text_sourceWise: 'Source-wise Revenue Report',
  reports_text_timeWiseOccupancy: 'Time-wise Venue Occupancy Percentage',
  reports_text_timeWiseHotelOccupancyPercentage: 'Time-wise Hotel Occupancy Percentage',
  reports_text_venuePerCustomer: 'Venue-wise Average Per Cover',
  reports_text_hotelWiseAPC: 'Hotel-wise Average Per Cover',
  reports_text_eventTypePerCustomer: 'Event-wise Average Per Cover Report',
  reports_text_timingPerCustomer: 'Timeslot-wise Average Per Cover Report',
  reports_text_sourceWiseActualization: 'Source-wise Actualization Report',
  reports_text_roomNightReport: 'Room Nights Report',
  venue_wise_report: 'Venue Wise Revenue Per',
  reports_text_hotelWiseRevenuePerArea: 'Hotel-wise Revenue Per',
  reports_title_text: 'Reports',
  reports_tax_exclusive_disclaimer: 'All data is exclusive of taxes',
  reports_performance_by_month_title: 'Performance by Month',
  reports_top_performers: 'Top performers',
  reports_top_venue: 'Top Venue',
  reports_top_source: 'Top Source',
  reports_top_manager: 'Top Manager',
  reports_display_amount: 'Amount',
  reports_display_achievement_pct: 'Achievement %',
  reports_demand_calendar_title: 'Demand Calendar',
  reports_demand_calendar_subtitle:
    'Which dates are getting maximum booking demand, even if we could not convert all of them.',
  reports_demand_calendar_high_demand_dates: 'High Demand Dates',
  reports_demand_calendar_overbooked_dates: 'Overbooked Dates',
  reports_demand_calendar_lost_demand: 'Lost Demand',
  reports_demand_calendar_avg_weekend_demand: 'Avg Demand per Weekend',
  reports_demand_calendar_top_demand_day: 'Top Demand Day',
  reports_demand_calendar_total_demand: 'Total Demand',
  reports_demand_calendar_revenue_potential: 'Revenue Potential',
  reports_demand_calendar_confirmed_revenue: 'Confirmed Revenue',
  reports_demand_calendar_lost_pending_potential: 'Lost / Pending Potential',
  reports_demand_calendar_venue_availability: 'Venue availability',
  reports_demand_calendar_available_venues: 'Available Venues',
  reports_demand_calendar_demand: 'Demand',
  reports_demand_calendar_export: 'Export Demand Calendar',
  reports_demand_calendar_org_high_demand: 'Org high demand date',
  reports_demand_calendar_high_demand_category: 'Category',
  reports_demand_calendar_previous_month: 'Previous month',
  reports_demand_calendar_next_month: 'Next month',
  reports_demand_calendar_select_month: 'Select month',
  reports_demand_calendar_high_demand_with_bookings: 'High demand dates with bookings',
  reports_demand_calendar_no_high_demand_bookings: 'No high demand dates with bookings this month',
  reports_demand_calendar_day_events: 'Events on this date',
  reports_demand_calendar_no_events: 'No events on this date',
  reports_demand_calendar_event: 'Event',
  reports_demand_calendar_status: 'Status',
  reports_venue_performance_by_month: 'Venue Performance by Month',
  reports_segment_performance_by_month: 'Segment Performance by Month',
  reports_source_performance_by_month: 'Source Performance by Month',
  reports_manager_performance_by_month: 'Manager Performance by Month',
  reports_dimension_venue: 'Venue',
  reports_dimension_segment: 'Segment',
  reports_dimension_source: 'Source',
  reports_dimension_manager: 'Manager',
  reports_kpi_annual_budget: 'Annual Budget',
  reports_kpi_revenue: 'Revenue',
  reports_kpi_achievement: 'Achievement',
  reports_kpi_gap: 'Gap',
  reports_kpi_conversion: 'Conversion',
  reports_tab_revenue_intelligence: 'Revenue Intelligence',
  reports_revenue_snapshot_achievement_pct: 'Achievement %',
  reports_revenue_snapshot_vs_last_year: 'vs Last Year',
  reports_revenue_snapshot_vs_previous_month: 'vs Previous Month',
  reports_revenue_snapshot_forecast_info:
    'Expected revenue captured at the start of the month: Confirmed bookings + 60% of Tentative + 30% of Waitlisted.',
  reports_revenue_snapshot_variance_info:
    'Actual revenue minus Budget for the month. The amount is the rupee difference; the percentage is variance divided by Budget.',
  reports_revenue_snapshot_achievement_info:
    'Actual revenue as a share of Budget: (Actual ÷ Budget) × 100. Shown for closed months when both values are available.',
  reports_budget_not_configured: 'Budget not set',
  reports_above_target: 'above target',
  reports_below_target: 'below target',
  reports_on_target: 'On target',
  reports_year_column_hint: 'Date range exceeds 12 months — showing yearly columns. Click a year to view months.',
  reports_cell_detail_title: 'Performance details',
  reports_booking_count: 'Booking count',
  reports_event_breakup: 'Event-wise breakup',
  reports_confirmed_tentative_split: 'Confirmed / Tentative',
  reports_click_cell_hint: 'Click a cell for budget, revenue, bookings, and event breakup.',
  reports_drilldown_table_title: 'Drill-down',
  reports_month_wise_details: 'Month-wise details',
  reports_no_performance_data: 'No performance data for the selected period.',
  reports_status: 'Status',
  reports_status_on_track: 'On track',
  reports_status_at_risk: 'At risk',
  reports_status_behind: 'Behind',
  reports_selected_period: 'Selected period',
  reports_filter_preset_this_fy: 'This FY (Apr-Mar)',
  consolidated_reports_title_text: 'Consolidated Reports',
  reports_text_rfq: 'RFQs',
  reports_text_complementary_bookings: 'Complementary',
  ckEditorPlaceholder: 'Type or paste your content here!',
  ckEditor_yellow_marker: 'Yellow Marker',
  ckEditor_green_marker: 'Red Marker',
  ckEditor_red_marker: 'Green Marker',
  rolesmgmt_button_add: 'New Role',
  rolesmgmt_button_privileges: 'Privileges',
  rolesmgmt_column_name: 'Role Name',
  rolesmgmt_title_edit: 'Edit Role',
  rolesmgmt_title_roles: 'Roles',
  roles_list_subtitle: 'Manage role names, assigned users, and privilege access.',
  privilege_success_message: 'Privileges updated successfully',
  roomType_button_add: 'Add Room Type',
  roomType_column_type: 'Room Type',
  roomType_text_type: 'Room Type',
  roomType_title_add: 'Add Room Type',
  roomType_title_edit: 'Edit Room Type',
  roomType_title_list: 'Room Types',
  roomType_list_subtitle: 'Used when configuring rooms and room inventory for properties.',
  room_button_add: 'Add Room',
  room_column_price: 'Price',
  room_column_type: 'Room Type',
  room_text_price: 'Price per Day',
  room_text_serviceCharge: 'Room Service Charge',
  room_text_taxGroup: 'Tax Group',
  room_text_taxCode: 'Tax Codes',
  room_text_type: 'Room Type',
  room_title_add: 'Add Room',
  room_title_edit: 'Edit Room',
  systemMessage_column_type: 'System Message Type',
  systemMessage_title_edit: 'Update System Message',
  systemMessage_title_list: 'System Message List',
  systemMessage_text_content: 'System Message Content',
  systemMessage_list_subtitle: 'Used for system and validation messages shown across the application.',
  tabs_text_bookingDetails: 'Billing breakdown',
  bookingDetails_booking_rooms: 'Booking Rooms',
  tabs_text_customerDetails: 'Customer',
  tabs_text_venueCustomerDetails: 'Overview',
  tabs_section_venueDetails: 'Venue Details',
  tabs_section_customerDetails: 'Customer Details',
  tabs_text_paymentDetails: 'Payment',
  tabs_text_historyDetails: 'History',
  tabs_text_logDetails: 'Activity',
  tabs_text_actual_revenue_excl_tax: 'Total Revenue (excl. Tax)',
  tabs_text_actual_revenue: 'Actualization',
  tabs_text_venueDetails: 'Venue',
  taxCode_column_name: 'Name',
  taxCode_column_percentage: 'Percentage',
  taxCode_text_name: 'Name',
  taxCode_text_code: 'Code',
  taxCode_text_surcharge: 'Surcharge',
  taxCode_text_percentage: 'Percentage',
  taxCode_title_add: 'Add Tax Code',
  taxCode_title_edit: 'Edit Tax Code',
  taxCode_title_list: 'Tax Codes',
  taxCode_list_subtitle: 'Used in tax groups, surcharges, rooms, add-ons, and booking line item tax calculations.',
  taxGroup_title_add: 'Add Tax Group',
  taxGroup_title_edit: 'Edit Tax Group',
  taxGroup_title_list: 'Tax Groups',
  taxGroup_list_subtitle: 'Used on rooms, add-ons, and venue pricing to apply mapped tax codes.',
  taxGroup_button_add: 'Add Tax Group',
  taxGroup_button_add_tax_code: 'Add Tax Code',
  taxGroup_field_name: 'Tax Group Name',
  taxGroup_section_tax_codes: 'Tax Codes',
  taxGroup_column_tax_code: 'Tax Code',
  taxGroup_column_scope: 'Scope',
  taxGroup_column_tax_code_count: 'Tax Codes',
  taxGroup_scope_same_state: 'Same State',
  taxGroup_scope_different_state: 'Different State',
  taxGroup_scope_always: 'Always Apply',
  taxGroup_empty_tax_codes: 'No tax codes added yet. Click "Add Tax Code" to configure tax codes for this group.',
  taxGroup_tax_codes_required: 'At least one tax code is required.',
  taxGroup_tax_code_row_incomplete: 'Complete tax code and scope for each row.',
  taxGroup_duplicate_tax_code: 'Each tax code can only be added once.',
  surcharge_button_add: 'Add surcharge',
  surcharge_title_add: 'Add surcharge',
  surcharge_title_edit: 'Edit surcharge',
  surcharge_title_list: 'Surcharges',
  surcharge_list_subtitle: 'Used on tax codes to apply additional percentage-based charges.',
  templateSchedule_column_name: 'Number of Days',
  templateSchedule_column_type: 'Type',
  templateSchedule_text_numberOfDays: 'Number of Days',
  templateSchedule_title_edit: 'Update Template Schedule',
  templateSchedule_title_list: 'Template Schedule',
  templateSchedule_list_subtitle: 'Used to schedule reminder and follow-up emails relative to booking dates.',
  timeSlot_button_add: 'Add Time Slot',
  timeSlot_column_endTime: 'End Time',
  timeSlot_column_name: 'Name',
  timeSlot_column_partOfDay: 'Part Of Day',
  timeSlot_column_startTime: 'Start Time',
  timeSlot_text_endTime: 'End Time',
  timeSlot_text_fullDay: 'Full Day',
  timeSlot_text_name: 'Name',
  timeSlot_text_partOfDay: 'Part Of Day',
  timeSlot_text_startTime: 'Start Time',
  timeSlot_title_add: 'Add Time Slot',
  timeSlot_title_edit: 'Edit Time Slot',
  timeSlot_title_list: 'Time Slot',
  updateProfile_title_text: 'User Profile',
  updateProfile_text_firstName: 'First Name',
  updateProfile_text_lastName: 'Last Name',
  updateProfile_text_email: 'Email',
  updateProfile_text_language: 'Language',
  updateProfile_text_country: 'Country',
  updateProfile_text_state: 'State',
  updateProfile_text_city: 'City',
  updateProfile_text_address: 'Address',
  updateProfile_text_pinCode: 'Postal Code',
  updateProfile_text_companyName: 'Company Name',
  updateProfile_text_designation: 'Designation',
  updateProfile_text_gst: 'GSTIN',
  updateProfile_text_role: 'Role',
  userprofile_button_updateProfile: 'Update Profile',
  updateProfile_text_org: 'Organization',
  usermgmt_button_active_user: 'Active user',
  usermgmt_button_in_active_user: 'In-active user',
  usermgmt_button_export: 'Export',
  usermgmt_button_import: 'Import',
  usermgmt_column_email: 'Email',
  usermgmt_column_phone: 'Phone No',
  usermgmt_text_company: 'Company Name',
  usermgmt_text_designation: 'Designation',
  usermgmt_text_firstName: 'First Name',
  usermgmt_text_lastName: 'Last Name',
  usermgmt_text_phone: 'Phone No',
  usermgmt_title_add: 'Add User',
  users_reporting_to: 'Reporting To',
  users_salutation: 'Salutation',
  users_list_subtitle: 'Manage staff access, roles, and property scope.',
  roles_text_name: 'Role Name',
  roles_title_add: 'Add Role',
  menu_text_roles_privileges: 'Roles & Privileges',
  venueConfig_general_highDemandStart: 'High-Demand Start Date',
  venueConfig_general_highDemandEnd: 'High-Demand End Date',
  venueConfig_general_highDemandName: 'High Demand Category',
  venueConfig_general_highDemandVenue: 'Dates',
  venueConfig_attributes_bookingPolicy: 'Booking Policy',
  venueConfig_attributes_contractTemplate: 'Contract Template',
  venueConfig_attributes_description: 'Description',
  venueConfig_attributes_floorPlan: 'Floor Plan',
  venueConfig_attributes_terms: 'Terms',
  venueConfig_button_new: 'New Venue Configuration',
  venueConfig_button_update: 'Update Venue Configuration',
  venueConfig_column_available: 'Available',
  venueConfig_column_confirmationBy: 'Confirmation By',
  venueConfig_column_segment: 'Segment',
  venueConfig_column_tentative: 'Tentative Allowed',
  venueConfig_column_venue: 'Venue',
  venueConfig_column_rfq: 'RFQ',
  venueConfig_general_availability: 'Availability',
  venueConfig_general_rfq: 'Request for Quote only',
  venueConfig_general_holdDays: 'Hold Days',
  bookingDetails_holdDays_tooltip:
    'This tentative booking will be automatically released on {date} if the advance is not received.',
  booking_holdDays_release_hint: 'Releases on {date}',
  booking_holdDays_release_hint_past: 'Was due for release on {date}',
  venueConfig_general_preLeadTime: 'Pre-event time',
  venueConfig_general_postLeadTime: 'Post-event time',
  venueConfig_general_maxCapacity: 'MaxBooking Capacity',
  venueConfig_general_minDays: 'Minimum Days Before Booking',
  venueConfig_general_minRevenue: 'Minimum Revenue',
  venueConfig_general_fixedHallRental: 'Fixed Hall Rental',
  venueConfig_general_tentative: 'Allow Tentative Bookings',
  venueConfig_general_unavailabilityEnd: 'Unavailability End Date',
  venueConfig_general_unavailabilityStart: 'Unavailability Start Date',
  venueConfig_general_venue: 'Venue',
  venueConfig_mapping_layout: 'Layout Selection',
  venueConfig_mapping_maxCapacity: 'Max Capacity',
  venueConfig_mapping_minCapacity: 'Min Capacity',
  venueConfig_mapping_tableLayouts: 'Layouts',
  venueConfig_mapping_tableMaxCapacity: 'Max. Capacity',
  venueConfig_mapping_tableMinCapacity: 'Min. Capacity',
  venueConfig_mapping_layout_capacity: 'Capacity: {min}-{max}',
  venueConfig_mapping_layouts_empty: 'No seating layouts are available for this organization.',
  venueConfig_mapping_layouts_inline_hint:
    'Enter min and max capacity on each seating style to include it in this configuration.',
  venueConfig_mapping_layout_set_capacity: 'Set capacity to include',
  venueConfig_mapping_layout_configured: 'Included in configuration',
  venueConfig_mapping_layout_clear: 'Remove from configuration',
  venueConfig_mapping_add_layout: 'Add layout',
  venueConfig_mapping_create_layout: 'Create new layout',
  venueConfig_mapping_select_layout: 'Select layout',
  venueConfig_mapping_timeslots: 'Time Slots',
  venueConfig_mapping_timeslots_windows_hint:
    'Define bookable time windows for this venue configuration (start and end time only).',
  venueConfig_mapping_timeslots_empty: 'No time slots are available for this organization.',
  venueConfig_mapping_timeslots_inline_hint:
    'Enter minimum revenue on each time slot to include it in this configuration.',
  venueConfig_mapping_timeslot_set_revenue: 'Set minimum revenue to include',
  venueConfig_mapping_timeslot_configured: 'Minimum revenue configured',
  venueConfig_mapping_timeslot_clear: 'Remove minimum revenue',
  venueConfig_timeslot_add: 'Add time slot',
  venueConfig_timeslot_revenue_add: 'Add minimum revenue rule',
  venueConfig_mapping_timeslot_revenue_empty:
    'No minimum revenue rules configured. Add one to set revenue by time window.',
  venueConfig_timeslot_start: 'Start time',
  venueConfig_timeslot_end: 'End time',
  venueConfig_timeslot_end_after_start: 'End time must be after start time',
  venueConfig_addons_categories: 'Add-on Categories',
  venueConfig_addons_select_entire_category: 'Select entire category',
  venueConfig_addons_search_placeholder: 'Search add-ons in this category...',
  venueConfig_addons_selected_count: '{count} add-on(s) selected',
  venueConfig_addons_none_selected: 'No add-ons selected',
  venueConfig_addons_empty: 'No add-ons available for this organization.',
  venueConfig_addons_no_results: 'No add-ons match your search.',
  venueConfig_addons_select_category: 'Select a category',
  venueConfig_addons_uncategorized: 'Other',
  venueConfig_payment_bookingConfirmation: 'Booking Confirmation',
  venueConfig_payment_minPercent: 'Min Confirmation Percentage',
  venueConfig_payment_serviceChargePercent: 'Service Charge Percentage',
  venueConfig_payment_slotOneBeforeDays: 'Payment Slot One Before Days',
  venueConfig_payment_slotOnePercent: 'Payment Slot One Percentage',
  venueConfig_payment_slotThreeBeforeDays: 'Full Payment Before Days',
  venueConfig_payment_slotThreePercent: 'Payment Slot Three Percentage',
  venueConfig_payment_slotTwoBeforeDays: 'Payment Slot Two Before Days',
  venueConfig_payment_slotTwoPercent: 'Payment Slot Two Percentage',
  venueConfig_price_columnPricePackage: 'Price Package',
  venueConfig_price_columnPricePerPerson: 'Price Per Person',
  venueConfig_price_endDate: 'End Date',
  venueConfig_price_pricePackage: 'Price Package',
  venueConfig_price_pricePerPerson: 'Price Per Person',
  venueConfig_price_priority: 'Priority',
  venueConfig_price_startDate: 'Start Date',
  venueConfig_price_titlePriceOverride: 'Price Override',
  venueConfig_price_title1PriceOverride: 'Price Override',
  venueConfig_price_titlePricePackage: 'Price Package',
  venueConfig_price_addPackage: 'Add price package',
  venueConfig_price_addOverride: 'Add price override',
  venueConfig_price_dragReorderHint: 'Drag cards to set priority. Top = highest priority (1).',
  venueConfig_price_priorityFromOrder: 'Priority',
  venueConfig_price_packages_empty: 'No price packages configured. Add one to set per-person pricing.',
  venueConfig_price_overrides_empty: 'No price overrides configured. Add one for date- or day-specific pricing.',
  venueConfig_price_selectPackage: 'Select package',
  venueConfig_price_pricePerPerson_required: 'Price per person is required',
  venueConfig_price_weekDays: 'Week Days',
  venueConfig_price_weekDays_selectAll: 'Select all',
  venueConfig_price_weekDays_all: 'All days',
  venueConfig_price_weekDays_count: '{count} days',
  venueConfig_addons_select_all: 'Select all add-ons',
  venueConfig_tabs_attributes: 'Localized Attributes',
  venueConfig_section_basicDetails: 'Basic Details',
  venueConfig_section_paymentDetails: 'Payment Details',
  venueConfig_tabs_general: 'General',
  venueConfig_tabs_mapping: 'Mapping',
  venueConfig_tabs_payment: 'Payment',
  venueConfig_tabs_price: 'Price',
  venueConfig_tabs_unavailability: 'Unavailability',
  venueConfig_unavailability_calendar_title: 'Unavailability calendar',
  venueConfig_unavailability_calendar_hint:
    'Orange highlights show days when the venue is unavailable for this configuration.',
  venueConfig_unavailability_dates_title: 'Unavailability dates',
  venueConfig_unavailability_dates_hint: 'Add date ranges when this configuration cannot be booked.',
  venueConfig_unavailability_dates_empty:
    'No unavailability dates yet. Add a date range to block booking on those days.',
  venueConfig_title_list: 'Venue Configuration',
  venueConfig_add: 'Add Configuration',
  venueConfig_bulk_create_button: 'Bulk Create Configs',
  venueConfig_bulk_create_title: 'Bulk Create Venue Configurations',
  venueConfig_bulk_create_step_hint: 'Step {current} of {total}',
  venueConfig_bulk_create_submit: 'Create Configurations',
  venueConfig_bulk_create_summary: 'Created {created}, skipped {skipped}, failed {failed}',
  venueConfig_edit: 'Edit Configuration',
  venueDetails_text_date: 'Event Date',
  venueDetails_bookingDate: 'Booking Date',
  venueDetails_text_description: 'Venue Description',
  venueDetails_text_segment: 'Segment',
  venueDetails_text_eventSubType: 'Event Type',
  venueDetails_text_guests: 'No. of Guests',
  venueDetails_text_name: 'Venue Name',
  venueDetails_text_timeSlots: 'Time Slot',
  venueType_button_add: 'New Venue Type',
  venueType_text_venueType: 'Venue Type',
  venueType_title_add: 'Create Venue Type',
  venueType_title_edit: 'Edit Venue Type',
  venueType_title_list: 'Venue Types',
  venueType_list_subtitle: 'Used when setting up venues and filtering venue-related bookings and reports.',
  venue_button_new: 'New Venue',
  venue_tab_information_text: 'Venue Information',
  venue_column_available: 'Available',
  venue_column_not_available: 'Not Available',
  venue_column_excessGuestPercent: 'Excess Guest %',
  venue_column_excessGuestRatePercent: 'Excess Guest Rate %',
  venue_column_name: 'Name',
  venue_list_title: 'Venue List',
  venue_text_availability: 'Availability',
  venue_text_description: 'Venue Description',
  venue_text_excessGuestPercent: 'Excess Guests',
  venue_text_excessGuestRatePercent: 'Excess guest rate %',
  venue_text_height: 'Height (ft)',
  venue_text_length: 'Length (ft)',
  venue_text_width: 'Width (ft)',
  venue_text_area: 'Area',
  venue_text_unit: 'sq ft',
  venue_text_name: 'Venue Name',
  venue_text_hsnCode: 'Hsn Code',
  venue_text_sort_order: 'Sort Order',
  venue_title_create: 'Create Venue',
  venue_title_edit: 'Edit Venue',
  venue_title_venueType: 'Venue type',
  budget_button_add: 'New Budget',
  budget_text_name: 'Budget Name',
  budget_text_target: 'Target',
  budget_text_month: 'Month',
  budget_text_start_date: 'Start Month',
  budget_text_end_date: 'End Month',
  budget_title_add: 'Add Budget',
  budget_title_edit: 'Edit Budget',
  budget_title_list: 'Budget',
  budget_tab_source_wise: 'Source-wise',
  budget_tab_venue_wise: 'Venue-wise',
  budget_tab_segment_wise: 'Segment-wise',
  budget_tab_manager_wise: 'Manager-wise',
  budget_allocation_summary: 'Allocation summary',
  budget_summary_total_target: 'Total target',
  budget_summary_source_allocated: 'Source allocated',
  budget_summary_venue_allocated: 'Venue allocated',
  budget_summary_segment_allocated: 'Segment allocated',
  budget_summary_manager_allocated: 'Manager allocated',
  budget_summary_remaining_by_view: 'Remaining (by view)',
  budget_summary_source_remaining: 'Source view',
  budget_summary_venue_remaining: 'Venue view',
  budget_summary_remaining: 'Remaining',
  budget_summary_left: 'left',
  budget_column_pct_of_total: '% of total',
  budget_column_completion: 'Share of total',
  budget_column_venue: 'Venue',
  budget_column_event_type: 'Event type',
  budget_column_manager: 'Manager',
  budget_empty_source_allocations: 'No source budgets yet.',
  budget_empty_venue_allocations: 'No venue budgets yet.',
  budget_empty_segment_allocations: 'No segment budgets yet.',
  budget_empty_manager_allocations: 'No manager budgets yet.',
  budget_allocation_exceeds_total: 'Allocated amount exceeds total budget for this view.',
  budget_month_required_message: 'Please select a month.',
  budget_allocation_progress_label: 'Allocation progress',
  add_source_budget: '+ Add Source Budget',
  add_venue_budget: '+ Add Venue Budget',
  add_segment_budget: '+ Add Segment Budget',
  add_manager_budget: '+ Add Manager Budget',
  budget_placeholder_select: 'Select',
  source_button_add: 'New Source',
  agent_column_email: 'Email',
  agent_column_name: 'Name',
  agent_column_phone: 'Phone No.',
  agent_column_status: 'Status',
  source_title_add: 'Add Source',
  source_title_edit: 'Edit Source',
  source_title_list: 'Source',
  source_list_subtitle: 'Used when tracking booking origin and filtering bookings by source.',
  revenue_owner_title_list: 'Revenue Owners',
  rfq_column_customer_name: 'Customer name',
  rfq_column_venue: 'Venue',
  rfq_column_preferredStartDate: ' Preferred Start Date',
  rfq_column_preferredEndDate: 'Preferred End Date',
  rfq_column_preferredDate: 'Preferred Date',
  rfq_column_guest: 'Guests',
  rfq_column_timeslot: 'Time Slot',
  rfq_not_specified: 'Not Specified',
  rfq_not_selected: 'Not Selected',
  rfq_column_segment: 'Segment',
  rfq_column_mobile: 'Mobile No.',
  rfq_column_createdDate: 'Created At',
  rfq_column_price_package: 'Price Package',
  rfq_column_company_name: 'Company Name',
  rfq_column_email: 'Email',
  rfq_column_status: 'Status',
  rfq_column_reason: 'Reason',
  rfq_lost_reason_title: 'Enter Reason for Lost RFQ',
  rfq_lost_dialog_subtitle: 'This enquiry will be closed and can no longer be converted into a booking.',
  rfq_lost_dialog_prompt: 'Please share why this RFQ was lost.',
  rfq_lost_reason_label: 'Lost reason',
  rfq_lost_reason_placeholder: 'e.g. Budget not approved, dates unavailable, chose another venue',
  rfq_lost_banner: 'This RFQ was marked as lost.',
  rfq_lost_banner_reason: 'Lost reason: {0}',
  rfq_title_list: 'Request For Quote',
  rfq_title_add: 'Add Request For Quote',
  rfq_btn_view_details: 'View Details',
  add_ammendment: 'Add Amendment',
  rfq_add_notes_text: 'RFQ Follow-ups',
  rfq_add_new_notes_text: 'Add Follow-ups',
  rfq_follow_up_description: 'Description',
  LoyaltyProgram: 'Loyalty Program',
  remark: 'Remark',
  name: 'Name',
  new_booking_title: 'New Booking',
  new_booking_review_events: 'Events',
  new_booking_review_event_count: '{count} events',
  new_booking_review_event_count_singular: '1 event',
  new_booking_review_room_count: '{count} rooms',
  new_booking_review_room_count_singular: '1 room',
  new_booking_review_guests: 'guests',
  new_booking_review_event_total: 'Total',
  payment_schedule_title: 'Payment Schedule',
  payment_schedule_subtitle: 'Set installment percentages and when each payment is due.',
  payment_schedule_total_allocated: 'Total allocated',
  payment_schedule_percent_allocated: '{percent}% allocated',
  payment_schedule_step: 'Step',
  payment_schedule_column_milestone: 'Milestone',
  payment_schedule_column_percent: '%',
  payment_schedule_column_due: 'Due',
  payment_schedule_confirmation: 'Confirmation',
  payment_schedule_first_instalment: '1st installment',
  payment_schedule_second_instalment: '2nd installment',
  payment_schedule_final_payment: 'Final payment',
  payment_schedule_on_confirmation: 'On confirmation',
  payment_schedule_on_event_day: 'On event day',
  payment_schedule_days_before: 'Days before',
  payment_schedule_days_order_warning_second:
    '2nd installment is due earlier than 1st (more days before the event). Later installments should have fewer days before.',
  payment_schedule_days_order_warning_final:
    'Final payment is due earlier than a previous installment (more days before the event). Later installments should have fewer days before.',
  new_booking_customer_first_name: 'Customer First Name',
  new_booking_customer_company_name_type: 'Type Company Name',
  new_booking_company_name: 'Company Name',
  new_booking_customer_additionalComments: 'Event Notes',
  new_booking_event_notes_placeholder: 'Add setup instructions, menu preferences, special arrangements...',
  new_booking_customer_phone: 'Customer Phone No',
  email: 'email',
  referenceNo: 'Reference Number',
  new_booking_customer_last_name: 'Customer Last Name',
  new_booking_customer_email: 'Customer Email',
  new_booking_segment: 'Segment',
  new_booking_event_sub_type: 'Event Type',
  new_booking_referred_by: 'Referred by',
  bookings_multiple: 'Add Venue details',
  add_bookings_multiple: 'Add Venue details',
  edit_bookings_multiple: 'Edit Venue details',
  clone_bookings_multiple: 'Clone Venue details',
  new_booking_venue_details_empty_title: 'No venues added yet.',
  new_booking_venue_details_empty_description: 'Add the venues, packages and add-ons required for this booking.',
  new_booking_add_venue_details: 'Add Venue Details',
  new_booking_add_venue_details_page: 'Add Venue Details (Page)',
  new_booking_venue_details_page_subtitle: 'Full-page preview for comparing against the drawer flow.',
  new_booking_venue_details_page_summary_title: 'Event Summary',
  new_booking_venue_details_page_summary_note: 'Preview only — sample data',
  new_booking_venue_details_page_summary_empty:
    'Fill venue, schedule, and pricing details to see the live cost breakdown.',
  new_booking_venue_details_page_summary_loading: 'Calculating…',
  new_booking_venue_details_saving: 'Saving…',
  pricing_insights_title: 'Pricing Insights',
  pricing_insights_similar_event_average: 'Similar Event Average',
  pricing_insights_estimate_vs_average: 'Your current estimate is {0}',
  pricing_insights_below_average: 'below average',
  pricing_insights_above_average: 'above average',
  pricing_insights_at_average: 'in line with average',
  pricing_insights_pct_below_average: '{0}% below average',
  pricing_insights_pct_above_average: '{0}% above average',
  pricing_insights_times_average: '{0}× average',
  pricing_insights_not_enough_data: 'Not enough historical data',
  pricing_insights_limited_data: 'Limited benchmark data',
  pricing_insights_based_on_bookings: 'Based on {0} similar bookings',
  pricing_insights_revenue_per_guest: 'Cost / Guest',
  pricing_insights_revenue_guest_label: 'Cost / Guest',
  pricing_insights_similar_rpg: 'Similar events average: {0}',
  pricing_insights_avg_in_parens: '(Avg: {0})',
  pricing_insights_pct_vs_average: '{0}% vs average',
  pricing_insights_discount_impact: 'Discount Impact',
  pricing_insights_standard_value: 'Standard value',
  pricing_insights_current_value: 'Current value',
  pricing_insights_std_in_parens: '(Std: {0})',
  pricing_insights_discount_lower: '{0} lower',
  pricing_insights_discount_delta: '{0}% ({1} lower)',
  new_booking_breadcrumb_booking: 'Bookings',
  new_booking_breadcrumb_events_venues: 'Events & Venues',
  new_booking_section_event_details: 'Event Details',
  new_booking_section_schedule: 'Schedule',
  new_booking_add_another_venue_detail: 'Add Another Venue Detail',
  new_booking_timeslot: 'Timeslot',
  new_booking_number_of_guests: 'Guaranteed Guests',
  new_booking_hall_rental: 'Hall Rental',
  new_booking_total_rental: 'Total Rental',
  new_booking_price_per_person: 'Price Per Person',
  new_booking_start_date: 'Start Date',
  new_booking_end_date: 'End Date',
  new_booking_status: 'Status',
  new_booking_venue: 'Venue',
  new_booking_column_date_time: 'Date & Time',
  new_booking_column_session_guests: 'Session & Guests',
  new_booking_column_guests: 'Guests',
  new_booking_column_event_type_package: 'Event Type / Package',
  new_booking_column_total: 'Est. Cost',
  new_booking_event_summary_error: 'Unable to calculate event summary. Please check line item details.',
  new_booking_package: 'Price Package',
  new_booking_custom_package_name: 'Custom Price Package Name',
  new_booking_laouts: 'Layouts',
  new_booking_service_charge: 'Service Charge',
  lineItemDateError:
    'You have changed the booking dates! Please select the line items dates accordingly to create the booking.',
  edit_booking_others_text: 'Booking Configuration',
  edit_booking_guaranteed_guests: 'Guaranteed Guests',
  edit_booking_Original_price_per_person: 'Original Price Per Person',
  edit_booking_Original_hall_rental: 'Original Hall Rental',
  edit_booking_Original_min_revenue: 'Original Minimum Revenue',
  edit_booking_Override_hall_rental: 'Override Hall Rental',
  edit_booking_Override_price_per_person: 'Override Price Per Person',
  edit_booking_Override_min_revenue: 'Override Minimum Revenue',
  pricing_override: 'Override',
  pricing_inherited: 'Inherited',
  pricing_edit: 'Edit',
  pricing_from_venue: 'from {name}',
  pricing_from_package: 'from {name}',
  pricing_original_value: 'Original: {amount}',
  pricing_original_with_source: 'Original: {amount} from {name}',
  pricing_unit_per_person: '/ person',
  pricing_unit_minimum_revenue: 'minimum',
  pricing_unit_fixed_hall_rental: 'fixed rental',
  pricing_unit_per_hour: '/ hour',
  pricing_field_fixed_hall_rental: 'Fixed Hall Rental',
  pricing_status_auto_venue: 'AUTO FROM VENUE',
  pricing_status_auto_package: 'AUTO FROM PACKAGE',
  pricing_status_inherited: 'INHERITED',
  pricing_status_overridden: 'OVERRIDDEN',
  pricing_info_aria: 'More information',
  pricing_info_price_per_person: 'Affects guest charges: total guest charges use guest count × price per person.',
  pricing_info_minimum_revenue:
    'Auto shortfall recovery: billing tops up to this minimum when guest charges and eligible add-ons fall short.',
  pricing_info_fixed_hall_rental:
    'Always added to total: this fixed amount is included in hall revenue on top of any minimum-revenue shortfall.',
  pricing_info_price_per_hour: 'Affects total rental: the hourly rate is multiplied by the booked hours window.',
  pricing_info_total_rental: 'Total rental equals booking hours × price per hour.',
  pricing_info_total_rental_value_prefix: 'Computed total',
  edit_booking_layouts: 'Layouts',
  edit_booking_hold_days: 'Hold Days',
  edit_booking_update_reason: 'Update Reason',
  location_button_add: 'New Location',
  location_title_add: 'Add Location',
  location_title_edit: 'Edit Location',
  location_title_list: 'Locations',
  location_title_listForMobile: 'Locations',
  location_list_subtitle: 'Used when setting up properties and filtering organization locations.',
  location_text_name: 'Name',
  organization_text_copy_url: 'Copy organization URL',
  dashboard_text_upcoming_booking: 'Upcoming Bookings',
  dashboard_text_tentative_booking: 'Tentative Bookings',
  dashboard_text_waitlisted_booking: 'Waitlisted Bookings',
  dashboard_text_upcoming_beos: 'Upcoming BEOs',
  dashboard_Request_for_quote: 'Request for Quote',
  dashboard_Request_for_edit: 'Edit Booking Request',
  dashboard_Request_for_cancel: 'Cancel Booking Request',
  dashboard_today_actions_empty:
    'Nothing due for today — no events, pending BEOs, collections, or tentative conversions.',
  required_error_prefix_message: 'Please enter valid details in',
  common_save_message: 'Data saved successfully.',
  common_update_message: 'Data updated successfully.',
  common_delete_message: 'Data deleted successfully.',
  common_endDate_error_message: 'End date can not be less than start date',
  common_endTime_error_message: 'End time can not be less than start time',
  common_sameDate_error_message: 'Start Date and End Date should not be same',
  captchaValidation: 'Captcha is required',
  unavailable_date: 'Add Unavailability date',
  unavailable_date_edit: 'Edit Unavailability date',
  unavailable_venue: 'Venue',
  unavailable_segment: 'Segment',
  unavailable_text: 'UNAVAILABLE',
  requiredText: 'This field is required',
  valid_pinCode_error: 'Please enter valid Postal Code',
  rfq_status_dropdown_new: 'NEW',
  rfq_status_dropdown_in_progress: 'IN_PROGRESS',
  rfq_status_dropdown_lost: 'LOST',
  dropdown_open_text: 'OPEN',
  dropdown_inProgress_text: 'IN_PROGRESS',
  dropdown_close_text: 'CLOSED',
  dropdown_cash_text: 'CASH',
  dropdown_debit_card_text: 'DEBIT CARD',
  dropdown_credit_card_text: 'CREDIT CARD',
  dropdown_netBanking_text: 'NET_BANKING',
  dropdown_cheque_text: 'CHEQUE',
  paymentStatus_Dropdown_confirmedText: 'CONFIRMED',
  paymentStatus_Dropdown_tentativeText: 'TENTATIVE',
  paymentStatus_Dropdown_waitlistText: 'WAITLISTED',
  dropdown_yes_text: 'Yes',
  dropdown_no_text: 'No',
  dropdown_active_text: 'Active',
  dropdown_inactive_text: 'Inactive',
  dropdown_all_text: 'All',
  dropdown_PartOfDay_breakfast_text: 'BREAKFAST',
  dropdown_PartOfDay_lunch_text: 'LUNCH',
  dropdown_PartOfDay_hi_tea_text: 'HI_TEA',
  dropdown_PartOfDay_dinner_text: 'DINNER',

  partOfDay_title_list: 'Part of Day',
  partOfDay_list_subtitle: 'Used when configuring bookings and availability by time of day.',
  partOfDay_title_add: 'Add Part of Day',
  partOfDay_title_edit: 'Edit Part of Day',
  partOfDay_dialog_subtitle_add: 'Configure a time slot for bookings, reports, and calendar views.',
  partOfDay_dialog_subtitle_edit: 'Update how this time slot appears across your organization.',
  partOfDay_section_basic: 'Basic details',
  partOfDay_section_appearance: 'Appearance',
  partOfDay_section_status: 'Status',
  partOfDay_preview_title: 'Live preview',
  partOfDay_preview_placeholder_name: 'Part of day name',
  partOfDay_preview_placeholder_code: 'CODE',
  partOfDay_color_presets_label: 'Quick color presets',
  partOfDay_color_hex_label: 'Hex code',
  partOfDay_color_invalid: 'Please enter a valid hex color (e.g. #66BB6A).',
  partOfDay_button_add: 'Add Part of Day',
  partOfDay_field_code: 'Code',
  partOfDay_field_scope: 'Scope',
  partOfDay_field_name: 'Name',
  partOfDay_field_color: 'Color',
  partOfDay_field_sort_order: 'Sort Order',
  partOfDay_field_active: 'Active',
  partOfDay_column_code: 'Code',
  partOfDay_column_name: 'Name',
  partOfDay_column_color: 'Color',
  partOfDay_column_sort_order: 'Sort Order',
  partOfDay_column_active: 'Active',
  partOfDay_column_scope: 'Scope',
  partOfDay_scope_parent: 'Parent',
  partOfDay_scope_organization: 'Organization',
  menu_text_part_of_day: 'Part of Day',
  organizations_tabs_part_of_day: 'Part of Day',
  dropdown_AddOnType_per_guest_text: 'Per guest',
  dropdown_AddOnType_per_quantity_text: 'Per quantity',
  dropdown_bookingConfirmationBy_venue_text: 'VENUE',
  dropdown_bookingConfirmationBy_block_pay_text: 'BLOCK_PAY',
  dropdown_bookingConfirmationBy_full_pay_text: 'FULL_PAY',
  bookingList_venue: 'Venue',
  bookingList_startDate: 'Start Date',
  bookingList_endDate: 'End Date',
  bookingList_timeSlot: 'Time-slot',
  bookingList_segment: 'Segment',
  bookingList_orderReference: 'Order Reference',
  bookingList_status: 'Status',
  bookingList_assignee: 'Assignee',
  bookingList_select_assignee: 'Select Assignee',

  menu_text_email_event_config: 'Email Event Triggers',
  attachment_configuration: 'Attachment Configuration',
  email_event_config_title_add: 'Add Email Event Configuration',
  email_event_config_title_edit: 'Edit Email Event Configuration',
  email_event_config_column_event_type: 'App. Event Type',
  email_event_config_column_mail_type: 'Mail Template Type',
  email_event_config_column_organizations: 'Organizations',
  email_event_config_column_to_role_name: 'To (Roles)',
  email_event_config_column_to_email_address: 'To (Email Addresses)',
  email_event_config_column_cc_role_name: 'CC (Roles)',
  email_event_config_column_cc_email_address: 'CC (Email Addresses)',
  email_event_config_column_admin_only: 'Send email to "Admin" only.',
  email_event_config_list_subtitle: 'Used to decide which email template and recipients fire for application events.',
  organization_mail_configuration_test_button: 'Send Test Email',
  organization_mail_configuration_test_info: 'A test email will be sent to the logged-in user.',
  organization_mail_configuration_test_success: 'Test email sent successfully.',
  smtp_password_configured_text: 'SMTP Password Configured',
  smtp_password_status_text: 'Password status',
  smtp_server_section_title: 'SMTP Server',
  smtp_settings_section_title: 'SMTP Settings',
  smtp_password_label: 'Password',
  advanced_settings_section_title: 'Advanced Settings',
  advanced_properties_section_title: 'Advanced Properties',
  actions_section_title: 'Actions',
  mail_configuration_subtitle: 'Configure SMTP settings for outbound email.',
  mail_configuration_password_configured_securely: 'Configured securely',
  mail_configuration_password_not_configured: 'Not configured',
  keep_existing_password_hint: 'Leave blank to keep the existing password.',
  mail_configuration_property_column: 'Property',
  mail_configuration_value_column: 'Value',
  mail_configuration_add_property_button: 'Add Property',
  mail_configuration_property_required_error: 'Add at least one property.',
  mail_configuration_property_row_error: 'Each property row must include both Property and Value.',
  mail_configuration_save_changes: 'Save Changes',
  mail_configuration_test_email_helper_prefix: 'Test email will be sent to',
  menu_text_address: 'Address Masters',
  email_server_config_column_additional_properties: 'Additional Properties',
  email_server_config_column_host: 'Host',
  email_server_config_column_user_name: 'User Name',
  email_server_config_column_password: 'Password',
  email_server_config_column_port: 'Port',
  common_button_reset: 'Reset',
  menu_text_payment_config: 'Payment Configuration',
  payment_config_list_subtitle: 'Used to connect organizations to payment gateways for online payments.',
  payment_config_column_hotel_Name: 'Hotel Name',
  payment_config_title_add: 'Add Payment Configuration',
  payment_config_title_edit: 'Edit Payment Configuration',
  payment_config_column_payment_provider: 'Payment Provider',
  payment_config_column_default_payment_gateway: 'Default Payment Gateway',
  payment_config_column_merchant_id: 'Merchant id',
  payment_config_column_merchant_password: 'Merchant password',
  payment_config_column_merchant_secret: 'Merchant secret',
  payment_config_column_merchant_username: 'Merchant user name',
  payment_config_column_merchant_transaction_currency: 'Transaction currency',
  payment_config_column_merchant_Transaction_wallet: 'Transaction wallet',
  payment_config_column_merchant_Sub_Account_Id: 'Sub Account Id',
  payment_config_column_merchant_RedirectUrl: 'Redirect url',
  payment_config_column_merchant_CancelUrl: 'Cancel url',
  payment_config_column_merchant_transaction_iso_currency: 'Transaction ISO currency',
  common_urlError: 'Please enter a valid URL.',
  no_data_found: 'No Data Available',
  common_validation_error: 'Please enter valid input',
  noApprovalPending: "You don't have any pending approval",
  booking_details_segment: 'Segment:',
  booking_details_no_of_guests: 'Pax:',
  booking_details_customer_name: 'Customer Name:',
  booking_details_sales_person: 'Created By:',
  calendar_tooltip_view_details: 'View booking details',
  calendar_tooltip_seating_style: 'Seating style',
  calendar_tooltip_price_package: 'Price package',
  calendar_tooltip_revenue: 'Revenue',
  calendar_tooltip_venue: 'Venue',
  calendar_tooltip_date_time: 'Date & time',
  calendar_tooltip_guests: 'Guests',
  calendar_tooltip_expected: 'Expected',
  calendar_tooltip_guaranteed: 'Guaranteed',
  calendar_tooltip_segment: 'Segment',
  calendar_tooltip_event_subtype: 'Event type',
  calendar_tooltip_flag_customer: 'Customer Booking',
  calendar_tooltip_flag_corporate: 'Corporate Booking',
  calendar_tooltip_flag_external: 'Created by IDS',
  calendar_tooltip_flag_ids: 'IDS Synced',
  calendar_tooltip_flag_rooms: 'Rooms Added',
  calendar_tooltip_flag_beo: 'BEO Released',
  calendar_tooltip_flag_programming: 'Programming Event',
  unavailable_header: 'Unavailable Venues',
  high_demand_header: 'High Demand Dates',
  booking_details_actual_revenue_name: 'Item Name',
  booking_details_actual_revenue_type: 'Type',
  booking_details_actual_revenue_quantity: 'Quantity',
  booking_details_actual_revenue_number_of_guest: 'Actual Guests',
  booking_details_actual_revenue_billable_guests: 'Billable Guests',
  booking_details_actual_revenue_excess_guest_rate: 'Excess Guests Rate',
  booking_details_actual_revenue_excess_guests: 'Excess Guests',
  booking_details_actual_revenue_extra_guest_rate: 'Extra Guest Rate',
  booking_details_actual_revenue_update_reason: 'Update Reason',
  booking_details_actual_revenue_price: 'Unit Price',
  booking_details_actual_revenue_total_price: 'Total Price',
  booking_details_actual_revenue_category: 'Category',
  booking_details_related_bookings: 'Related Bookings',
  booking_details_related_revenue: 'Revenue',
  addNewSourceWiseBudget: '+ Add Source Budget',
  editNewSourceWiseBudget: 'Edit source budget',
  new_booking_guests: 'Guests',
  new_booking_venue_error: 'Please select Venue before selecting Time slot and Price Package',
  new_booking_select_venue_first: 'Please select venue',
  new_booking_segment_error: 'Please select Segment before selecting Time slot and Price Package',
  bookingDetails_text_referred_by: 'Referred By',
  venue_text_Booking_window: 'Booking Window',
  theme_primary_color: 'Primary Color',
  theme_secondary_color: 'Secondary Color',
  theme_primary_text_color: 'Primary Text Color',
  theme_button_text: 'Update Theme',
  theme_secondary_text_color: 'Secondary Text Color',
  theme_logo_background_color: 'Logo Background Color',
  language_dropdown_placeholder_text: 'Choose language',
  organization_dropdown_placeholder_text: 'Select Organization',
  bookingConfirmSuccess: 'Booking Confirmed Successfully',
  bookingCancelSuccess: 'Booking Cancelled Successfully',
  bookingDeletionSuccess: 'Booking Deleted Successfully',
  bookingDeletionNote: `Note: Deleting a booking will remove all associated data, and this action cannot be reversed. Ensure that this is the correct action before proceeding.`,
  bookingStatusChangeSuccess: 'Booking Status Changed Successfully',
  processRefundSuccess: 'Refund Processed Successfully',
  lineItemError: 'Please add at least one row in booking line items',
  AddNewRoom: 'Add Room',
  AddRoom: 'Add Room',
  editRoom: 'Edit Room',
  NewBookingSuccess: 'Success! ',
  NewBookingSuccessPart1: 'Please click on ',
  NewBookingSuccessPart2: 'Edit Booking',
  NewBookingSuccessPart3: ' to add Rooms and Add-ons',
  newBooking_payment_minPercent: 'Min Confirmation %',
  newBooking_payment_slotOnePercent: '1st Installment %',
  newBooking_payment_slotTwoPercent: '2nd Installment %',
  newBooking_payment_slotThreePercent: '3rd Installment %',
  newBooking_payment_slotOneBeforeDays: 'Slot 1 Days Before',
  newBooking_payment_slotTwoBeforeDays: 'Slot 2 Days Before',
  newBooking_payment_slotThreeBeforeDays: 'Full Pay Days Before',
  import_booking_file_upload: 'Import booking done successfully',
  import_booking_button: 'Upload',
  import_booking_template_text: 'Download import booking template',
  download_template_text: 'Download template',
  import_booking_error: 'Please download excel file and check the error',
  common_button_create: 'Create Booking',
  sendAttachment: 'Send Attachment',
  menu_text_organization_master_data: 'Org Master Data',
  organization_master_data_column_key: 'Key',
  organization_master_data_column_value: 'Master Data Value',
  organization_master_data_column_input: 'Master Data Value (comma separated value)',
  organization_master_data_column_data_type: 'Data Type',
  edit_organization_master_data: 'Edit Organization Master Data',
  add_organization_master_data: 'Add Organization Master Data',
  organization_master_data_custom_key: 'Custom Key',
  organization_master_data_custom_key_option: 'Custom (free text)',
  user_profile_edit_profile: 'Edit Profile',
  user_profile_change_password: 'Change Password',
  user_profile_section_personal: 'Personal Information',
  user_profile_section_work: 'Work & Company',
  user_profile_section_address: 'Address',
  user_profile_email_cannot_change: 'Cannot be changed',
  password_validation_message:
    'Password length should be between 8 and 15 characters and must contain at least one lowercase letter, one uppercase letter, one numeric digit and one special character',
  old_password_text: 'Old Password',
  new_password_text: 'New Password',
  confirm_password_text: 'Confirm Password',
  change_password_error_message: 'New Password and Confirm Password are not same',
  copyDatesToAllSegments: 'Sync changes to all segments for this venue',
  venueConfig_syncToSegments: 'Sync to all segments for this venue',
  venueConfig_syncToSegments_success: 'Configuration synced to {count} other segment(s) for this venue',
  venueConfig_syncToSegments_none: 'No other segments found for this venue',
  venueConfig_sync_confirm_title: 'Sync configuration to other segments?',
  venueConfig_sync_confirm_body:
    'This will copy this configuration to all other event segments for the same venue. Existing settings on those segments may be overwritten.',
  venueConfig_sync_confirm_action: 'Sync now',
  venueConfig_clone_tooltip: 'Clone this configuration',
  venueConfig_clone_confirm_title: 'Clone this configuration?',
  venueConfig_clone_confirm_body:
    'A new venue configuration will be created as a copy. You will be taken to the new configuration to review and save.',
  venueConfig_clone_confirm_action: 'Clone',
  email_invalid_error: 'Please enter a valid email address',
  phone_no_invalid_error: 'Please enter a valid phone no',
  today_text: 'Today',
  past_7Days_text: 'Past 7 days',
  past_15Days_text: 'Past 15 days',
  past_30Days_text: 'Past 30 days',
  past_60Days_text: 'Past 60 days',
  next_day_text: 'Next day',
  future_7Days_text: 'Next 7 days',
  future_15Days_text: 'Next 15 days',
  future_30Days_text: 'Next 30 days',
  future_60Days_text: 'Next 60 days',
  future_3Days_text: 'Next 3 days',
  next_week: 'Next Week',
  chargesSummaryText: 'Charges Summary',
  totalText: 'Total',
  change_theme_text: 'Modify Admin Theme',
  change_customer_theme_text: 'Modify Customer Theme',
  logoutText: 'Logout',
  address_title_list: 'Address Masters',
  address_list_subtitle: 'Manage countries, states, and cities used across properties and customer addresses.',
  address_button_add: 'Add',
  address_column_name: 'Name',
  actualRevenueAddSuccessText: 'Actual revenue updated successfully',
  billPostSuccessText: 'Bill posting successful',
  menu_text_meal_plan: 'Meal Plans',
  mealPlan_title_list: 'Meal Plans',
  mealPlan_list_subtitle: 'Used when configuring room meal plans and meal pricing for rooms.',
  meal_plan_title_edit: 'Edit Meal Plan',
  meal_plan_title_add: 'Add Meal Plan',
  mealPlan_button_add: 'New Meal Plan',
  meal_plan_column_name: 'Meal Plan',
  meal_plan_price_column_name: 'Price',
  addRoomMealConfigBudget: 'Add Meal Type Configuration',
  editRoomMealConfigBudget: 'Edit Meal Type Configuration',
  add_address_text: 'Add Country/State/City',
  edit_address_text: 'Edit Country/State/City',
  address_form_text_state: 'State',
  address_form_text_city: 'City',
  address_form_text_country: 'Country',
  addOnPriceError: '(Add-on) price cannot be negative',
  addOn_Error: '(Add-on) quantity must be greater than 0',
  addOn_MaxCountError: '(Add-on) quantity must be less than max Quantity',
  addOn_QuantityLimitError: '(Add-on) quantity cannot exceed 1,00,000',
  venueConfig_mapping_maxCapacity_error: 'Max Capacity should be greater than Min Capacity',
  add_BEO_Text: 'Add BEO',
  beo_page_subtitle: 'Create and share banquet event order for this event.',
  beo_last_updated: 'Last Updated',
  beo_status_not_distributed: 'Not yet distributed.',
  beo_status_distributed: 'Distributed to staff.',
  beo_locked_banner_title: 'This BEO has been distributed.',
  beo_locked_banner_body:
    'All BEO details are locked and cannot be edited. Add an amendment to communicate any changes.',
  beo_completed_banner_title: 'BEO Completed',
  beo_completed_banner_distributed: 'Distributed',
  beo_completed_banner_body: 'This BEO is read-only and available for reference.',
  beo_completed_banner_body_dated:
    'Event completed on {date}. This BEO is read-only and available for reference.',
  beo_add_amendment: '+ Add Amendment',
  beo_amendment_added_by: 'Added by {name}',
  board_to_read: 'Board to Read',
  beo_name: 'BEO Name',
  beo_menu_text: 'Menu',
  beo_program_text: 'Banquet Operations',
  beo_room_setup_text: 'Room Setup',
  beo_decor_text: 'Housekeeping',
  beo_engineering_text: 'Engineering',
  beo_security_text: 'Security',
  beo_audio_visual_text: 'Audio Visual',
  beo_section_food_beverage: 'Food & Beverage',
  beo_section_banquet_setup: 'Banquet Setup',
  beo_section_technical: 'Technical',
  beo_section_operations: 'Operations',
  beo_section_commercials_billing: 'Commercials & Billing',
  beo_billing_details_section_header_text: 'Billing Details',
  beo_billing_details_customer_name: 'Customer / Company Name',
  beo_billing_details_address: 'Billing Address',
  beo_billing_details_tax_no: 'GSTIN',
  beo_billing_details_price_per_hour: 'Rate per Hour',
  beo_billing_details_price_per_person: 'Rate per Person',
  beo_billing_details_minimum_revenue: 'Minimum Revenue',
  beo_billing_details_hall_rental: 'Hall Rental',
  beo_billing_details_total_rental: 'Total Rental',
  beo_add_on_section_header_text: 'Add-on Charges',
  beo_add_on_name: 'Add-on',
  beo_add_on_quantity: 'Quantity',
  beo_add_on_price: 'Price',
  beo_add_on_total: 'Total',
  beo_event_price_per_person: 'Price / Person',
  beo_event_price_per_hour: 'Price / Hour',
  beo_event_service_charge: 'Service Charge',
  beo_event_add_ons: 'Add-ons',
  beo_event_add_ons_price: 'Add-ons Price',
  beo_event_no_add_ons: 'No add-ons',
  beo_event_view_n_add_on: 'View {count} add-on →',
  beo_event_view_n_add_ons: 'View {count} add-ons →',
  beo_event_min_revenue: 'Min. Revenue',
  beo_event_view: 'View',
  beo_event_commercials: 'Commercials',
  beo_event_view_breakdown: 'View full breakdown',
  beo_event_view_add_ons: 'View add-ons',
  beo_event_time: 'Time',
  beo_event_seating_style: 'Seating Style',
  beo_event_seating_not_set: 'Seating not set',
  beo_event_tax: 'Tax',
  beo_payment_history_header_text: 'Payment Summary',
  beo_payment_history_amount_received: 'Payment Received',
  beo_payment_history_amount_due: 'Balance Due',
  beo_payment_history_total_cost: 'Total Cost',
  beo_payment_history_date: 'Date',
  beo_payment_history_amount: 'Amount',
  beo_payment_history_payment_mode: 'Mode',
  beo_payment_history_payment_reference: 'Reference',
  beo_beverage_text: 'Beverages',
  beo_billing_text: 'Billing',
  beo_notes_text: 'General Notes',
  beo_notes_placeholder: 'Add instructions applicable to the entire event...',
  beo_notes_hint: 'These are general BEO notes. Put departmental instructions in the sections above.',
  beo_miscellaneous_text: 'Miscellaneous/Extras',
  beo_include_details_text: 'Include BEO Details',
  beo_include_amendments_text: 'Include Amendments',
  BEO_details_text: 'View BEO Details',
  update_BEO_text: 'Update BEO',
  beo_date_text: 'Date',
  beo_start_time_text: 'Start Time',
  beo_end_time_text: 'End Time',
  beo_function_time_text: 'Function Time',
  deleteBooking: 'Delete Booking',
  billPostText: 'Post Bill',
  voidBillText: 'Void Bill',
  postBillConfirmTitle: 'Post bill to {{pmsName}}?',
  postBillConfirmMessage:
    'You are about to post this actualization to {{pmsName}}, your connected property-management system. Event charges will be sent to the guest folio. To change actualization after posting, you must void the bill first. Do you want to continue?',
  pmsBillFlowInfoMessage: 'Transfer to Room is enabled. Save your changes, then use Post Bill when ready.',
  operaBillFlowInfoMessage:
    'Save your changes, then use Post Bill when ready. Without Transfer to Room, charges will be posted to the Opera Pay Master room.',
  pmsBillPostedSuccessMessage: 'Actualization has been posted successfully.',
  noGstinEInvoiceMessage:
    'No buyer GSTIN is on this booking (Customer Details tab). E-invoice (Validate / Generate IRN) is not available until a GSTIN is added.',
  postClearTaxText: 'Generate IRN',
  validateEInvoiceText: 'Validate e-Invoice',
  validateEInvoiceSuccessText: 'e-Invoice validated successfully',
  readyForIrnGenerationText: 'Ready for IRN Generation',
  validateEInvoiceSuccessShortText: 'Validated',
  downloadEInvoicePdfText: 'Download e-Invoice',
  eInvoiceDownloadErrorsTitle: 'Could not download e-Invoice',
  generateIrnConfirmTitle: 'Generate IRN?',
  generateIrnConfirmMessage:
    'Once generated, this invoice will be registered with GST/IRP.\n\nPlease confirm invoice number, GSTIN, tax amounts and buyer details.',
  clearTaxPostSuccessText: 'IRN generated successfully',
  eInvoiceErrorsCardTitle: 'e-Invoice errors',
  eInvoiceErrorsCardHint: 'Fix the issues below and try again.',
  eInvoiceErrorsDismiss: 'Dismiss',
  eInvoiceValidationErrorsTitle: 'Cannot validate e-Invoice',
  eInvoiceGenerateErrorsTitle: 'Could not generate IRN',
  eInvoiceNoIrnReturned: 'ClearTax did not return an IRN. Check the response details or try again.',
  clearTaxValidationTitle: 'Cannot generate IRN',
  clearTaxValidationActualizationRequired: 'Save actualization before generating IRN.',
  cancelIrnText: 'Cancel IRN',
  cancelIrnSuccessText: 'IRN cancelled successfully',
  cancelIrnConfirmTitle: 'Cancel IRN',
  cancelIrnConfirmMessage: 'Are you sure you want to cancel this IRN? This action cannot be undone.',
  cancelIrnReasonLabel: 'Cancellation Reason',
  cancelIrnRemarksLabel: 'Remarks',
  irnNumberLabel: 'IRN',
  irnCopyText: 'Copy IRN',
  irnCopiedText: 'IRN copied to clipboard.',
  irnGeneratedSuccessMessage: 'IRN has been generated successfully for this actualization.',
  qrCodeLabel: 'Payment QR Code',
  clearTaxValidationTotalCostRequired: 'Invoice total must be greater than zero.',
  clearTaxValidationGstRequired: 'Buyer GSTIN is required on the booking (Customer Details tab).',
  clearTaxValidationLegalNameRequired: 'Buyer company or customer name is required on the booking.',
  clearTaxValidationAddressRequired: 'Buyer address is required on the booking.',
  clearTaxValidationLocationRequired: 'Buyer city or state is required on the booking.',
  clearTaxValidationPinCodeRequired: 'Buyer PIN code is required on the booking.',
  clearTaxValidationPinCodeInvalid: 'Buyer PIN code format is invalid.',
  beo_setup_text: 'Seating Style',
  beo_venue_details: 'Venue details',
  beo_gtd_text: 'GTD',
  beo_guaranteed_guests_text: 'Guaranteed Guests',
  bookings_button_save_preview_beo: 'Save & Preview BEO',
  bookings_button_preview_beo: 'Preview BEO',
  bookings_button_download_beo: 'Download BEO',
  bookings_button_send_beo: 'Send BEO to Customer',
  bookings_button_send_beo_to_admin: 'Send BEO to Staff',
  bookings_button_send_revision_to_staff: 'Send Revision to Staff',
  bookings_button_send_bed_to_admin: 'Send BOD to Staffs',
  bookings_button_send: 'Send',
  beo_to_email_text: 'To',
  beo_cc_email_text: 'Cc',
  beo_bcc_email_text: 'Bcc',
  beo_name_error: 'BEO name is required',
  beo_email_successMsg: 'Email sent successfully',
  no_beo_added_text: 'No BEO added for this booking.',
  no_beo_added_button: 'No BEO Created',
  no_actualization_added_text: 'This booking has not been actualized.',
  date_format_error: 'Please enter a valid date',
  time_format_error: 'Please enter valid time',
  error_page_back_to_add_organization_text: 'Back to Add Organization',
  error_page_desc_text: 'Do not worry though, there is always a way to go back home',
  error_page_back_home_text: 'Back Home',
  error_page_service_unavailable_text: 'Service Unavailable !!!',
  page_not_found_desc_text: "Sorry, The page you're looking for doesn't exist",
  upload_button_text: 'Choose Files',
  view_less_text: 'View Less',
  view_more_text: 'View More',
  more: 'more',
  flatDiscountError: 'Discount cannot be more that 9999999999',
  percentDiscountError: 'Discount cannot be more that 100% ',
  edit_user_text: 'Edit User',
  hrsText: '(24 Hrs)',
  add_payment_error: 'Pan card No. and Upload document is mandatory',
  filter: 'Filter',
  details_on_text: 'Details on',
  budget_target_required_message: 'Please enter target',
  delete_success_message: 'Row has been deleted Successfully',
  cancelText: 'Cancel',
  unsavedChangesTitle: 'Unsaved changes',
  unsavedChangesSubtitle: 'Actualization',
  unsavedChangesCallout: 'You have unsaved changes on this actualization.',
  unsavedChangesBody: 'Save your work before continuing, or discard to proceed without saving.',
  unsavedChangesDiscard: 'Discard changes',
  unsavedChangesSaveContinue: 'Save & continue',
  unsavedChangesSaving: 'Saving…',
  beoUnsavedChangesSubtitle: 'Banquet Event Order',
  beoUnsavedChangesCallout: 'You have unsaved changes on this BEO.',
  beoUnsavedChangesBody: 'Save the BEO before continuing, or discard your changes to continue without saving.',
  copied_successfully_text: 'Copy successfully...',
  timeslot_minRevenue_drawer_title: 'TimeSlot Minimum Revenue',
  timeslot_text: 'TimeSlot',
  minimum_revenue_text: 'Minimum Revenue',
  countryText: 'country',
  stateText: 'state',
  cityText: 'city',
  addressSuccessText1: 'has been',
  addressSuccessText2: 'added',
  addressSuccessText3: 'updated',
  addressSuccessText4: 'successfully...',
  addressNoteText1: 'Note: it will delete all the',
  addressNoteText2: 'mapped against the ',
  statesText: 'states',
  citiesText: 'cities',
  templeteScheduleTentativeBookingsText: 'For Tentative Bookings:',
  templeteScheduleText1: 'Booking Date + Hold Days + (Configured days) = ',
  templeteScheduleText2: 'You will receive the email based on above configuration on: ',
  templeteScheduleText3: 'For Bookings with status Confirmed and payment status as Partially Paid/Pending:',
  templeteScheduleText4: 'Event Start Date + (-payment slot before days + (Configured days)) = ',
  templeteScheduleConfirmedBookingText: 'For Confirmed Bookings:',
  templeteScheduleText5: 'Event End Date + (Configured days) = ',
  newBookingStartDateError: 'Please enter the start date for all the booking line items.',
  functionNotImplementedError: 'Function not implemented.',
  createNewBookingText: 'Create New Booking',
  applyFilterText: 'Apply Filter',
  clearFilterText: 'Clear Filter',
  invalidHoldDaysMsg: 'Please enter valid Hold days (max 1800)',
  timeslotRequired: 'Timeslot is required',
  insufficient_length: 'Insufficient Length. Min length: {0} characters required.',
  exceeded_character_limit: 'Exceeded Character Limit. Max length: {0} characters.',
  common_number_validation_error: 'Please enter a valid number',
  common_min_value_error: 'Value cannot be less than {0}',
  common_max_value_error: 'The value should not exceed {0}',
  cancel_reason_length_error: 'Cancel reason should not exceed {0} characters',
  min_date_error: 'Please enter date greater than {0}',
  max_date_error: 'Please enter date less than {0}',
  addressConfirmDelete: 'Are you sure you want to delete this {0}?',
  invalid_email_message: '"{0}" is not a valid email address',
  haveAnAcountText: 'Have an account? Login',
  lessThaZeroError: 'Value cannot be less than 0',
  datePickerValidation: 'Start date cannot be greater than end date',
  timePickerValidation: 'Start time cannot be same or greater than end time',
  clear_filter: 'Clear',
  searchButtonText: 'Search',
  checkAvailabilityText: 'Check Availability',
  bookBanquetModifyText: 'Modify Search',
  no_venue_Found_error_message:
    'We could not find any matching venues. Please try again by changing your search options.',
  searchBar_Text_location: 'Location',
  searchBar_Text_eventType: 'Segment',
  searchBar_Text_NoOfGuest: 'No of Guest',
  common_text_startDate: 'Start Date',
  common_text_endDate: 'End Date',
  pricePerDay: 'Room Price per Day',
  noImageAvailableText: 'No Image Available',
  viewDetailButton: 'View Details',
  readMoreText: ' ... Read More',
  showLessText: ' ... Show Less',
  perPersonText: 'Per Person',
  hallRental: 'Hall Rental',
  rfq_modal_text_event_type: 'Segment',
  rfq_modal_text_event_time: 'Time of the Event',
  rfq_modal_text_guests: 'Number of Guests',
  rfq_modal_text_venue: 'Venue',
  rfq_modal_text_date: 'Preferred Start Date',
  rfq_modal_text_end_date: 'Preferred End Date',
  rfq_modal_text_full_name: 'Full Name',
  rfq_modal_text_mobile: 'Mobile',
  rfq_modal_text_email: 'Email',
  rfq_stats_total: 'Total',
  rfq_stats_new: 'New',
  rfq_stats_in_progress: 'In-Progress',
  rfq_stats_converted: 'Converted',
  rfq_stats_lost: 'Lost',
  rfq_stats_conversion_rate: 'Conversion',
  inPipeline: 'In Pipeline',
  rfq_max_capacity_error: 'Selected venue cannot accommodate {0} guests',
  areYouSureText: 'Are you sure?',
  continueText: 'Continue',
  floorPlan: 'Floor Plan',
  venue_text_length_unit: 'ft.',
  bookNowText: 'Book Now',
  removeText: 'Remove',
  termsConditionText: 'Terms & Conditions',
  rfq_modal_text_title_name: 'Request For Quote',
  venueAvailableText: 'AVAILABLE',
  venueWaitlistedText: 'WAITLISTED',
  aboutTabText: 'About',
  venues: 'Venues',
  rfqSuccessMessage: 'Form successfully submitted.',
  checkAvailableVenuesText: 'Check available venues',
  venuesNoAvailableText1: ' We are sorry there are no venues available right now.',
  venuesNoAvailableText2: ' Would you like to check for an alternate date and time?',
  no_venue_alternate_date:
    'Venues are not available for your selected dates. Please check the availability for alternate below',
  selectedVenueListHeaderText: 'Selected Venue List',
  cancel_text: 'Cancel',
  selectedDateMessage: 'You have not selected venues for all dates. Do you want to continue?',
  okText: 'Ok',
  termsText: 'I have read and I agree to the terms and condtions for the below venue(s)',
  submitText: 'SUBMIT',
  selectAnOrg: 'Select an organization',
  selectAtLeastOneOrg: 'Please select at least one organization',
  selectAddOnType: 'select any Add-on category',
  searchByCategory: 'search by Add-on category',
  lineItemStatusRequiredText: 'Please enter status for all the booking line items',
  lineItemTimeslotRequiredText: 'Please enter timeSlot for all the booking line items',
  lineItemPricePackageRequiredText: 'Please enter price package for all the booking line items',
  roomsDateRequiredText: 'Please enter check in and check out dates for all the selected rooms',
  completed: 'Completed',
  copy: 'Copy',
  missingFields: 'Missing fields',
  bookingLineItems: 'Venue Details',
  hoverText: 'Completion is based on required configuration sections. Open a record to see the full breakdown.',
  venueConfig_health_title: 'Configuration Health: {percent}% Complete',
  venueConfig_column_health: 'Health',
  copyFromWordText: 'Formatting tip: Paste from Word or plain text.',
  exportBod: 'Export BOD',
  sendBodToStaffS: 'Send to Staffs',
  maxFileSizeErrorMessage: "Drag 'n' drop some files here, or click to select files(Max file size 10mb)",
  upload_document: 'Upload Document',
  uploadHotelInvoice: 'For credit to company document details are mandatory',
  amountGreaterThanZero: 'Amount should be greater than 0.',
  crm_system: 'Sales Management',
  lead_management: 'Sales Companies',
  lead_management_list_subtitle: 'Manage sales companies, categories, industry types, and account managers.',
  lead_management_button_add: 'Add Sales Company',
  lead_management_add: 'Add Sales Company',
  lead_management_secondary_account_manager: 'Secondary Account Manager',
  lead_management_edit: 'Edit Sales Company',
  addConatctDetails: 'Add Contact Details',
  editConatctDetails: 'Edit Contact Details',
  company_profile: 'Company Profile',
  lead_management_contact_details_title: 'Salutation',
  lead_management_contact_details_firstname: 'First Name',
  lead_management_contact_details_lastname: 'Last Name',
  lead_management_contact_details_email: 'Email',
  lead_management_contact_details_contact_no: 'Contact No',
  lead_management_contact_details_designation: 'Designation',
  lead_management_contact_details_company_name: 'Company Name',
  lead_management_contact_details_company_category: 'Company Category',
  lead_management_contact_details_industry_type: 'Industry Type',
  lead_management_contact_details_assignedTo: 'Assigned To',
  lead_management_contact_details_primaryManager: 'Primary Acc. Managers',
  lead_management_contact_details_secondaryManager: 'Account Manager',
  lead_management_contact_details_status: 'Status',
  lead_management_contact_details_country: 'Country',
  lead_management_contact_details_city: 'City',
  lead_management_type_of_account: 'Type of Account',
  lead_management_headquarter_details: 'Headquarter Details',
  lead_management_headquarter_address: 'Address',
  lead_management_headquarter_phone: 'Contact No.',
  lead_management_headquarter_email: 'Email',
  lead_management_headquarter_website: 'Website',
  sales_company_name: 'Company Name',
  sales_reports: 'Sales Report',
  sales_reports_subtitle: 'Track daily activity, portfolio mix, and room-night performance.',
  sales_portfolio_report: 'Portfolio Report',
  sales_company_branch_section: 'Branch Offices',
  sales_company_branch_name: 'Office',
  sales_company_branch_address: 'Address',
  sales_management_branch_city_potential: 'Add City Potential',
  sales_management_branch_competitions_city: 'City',
  sales_management_branch_competitions_region: 'Region',
  sales_management_branch_competitions_hotel_name: 'Competition Hotel',
  sales_management_branch_competitions_reason: 'Reason',
  sales_management_branch_competitions_fit_section: 'FIT (My Potential /Target)',
  sales_management_branch_competitions_fit_nights: 'Nights (Per Year)',
  sales_management_branch_competitions_fit_room_potential: 'Avg. Revenue',
  sales_management_branch_competitions_mice_section: 'MICE (Meetings, Incentives, Conferences, Exhibitions)',
  sales_management_branch_competitions_mice_event_section: 'Add MICE Event',
  sales_management_branch_competitions_mice_event_count: 'Event Count',
  sales_management_branch_competitions_mice_event_rate: 'Avg. Event Rate',
  sales_management_branch_competitions_mice_event_pax: 'No. of Pax',
  sales_management_branch_competitions_mice_event_room_nights: 'Room Nights',
  sales_management_branch_competitions_mice_event_potential_revenue: 'Potential Revenue',
  sales_management_branch_competitions_total_city_potential_section: 'Total City Potential',
  sales_management_branch_competitions_my_potential_nights: 'Room Nights',
  sales_management_branch_competitions_my_potential_rate: 'Rooms Revenue',
  sales_management_branch_competitions_my_potential_event_count: 'Event Count',
  sales_management_branch_competitions_my_potential_event_rate: 'Events Revenue',
  sales_management_branch_add_competitions_heading: 'Add Competition Hotel',
  sales_management_branch_competitions_column_hotel_name: 'Competition Hotel',
  sales_management_branch_competitions_column_fit_potential: 'FIT Nights Potential',
  sales_management_branch_competitions_column_mice_potential: 'Avg. Rate',
  sales_management_branch_duplicate_competitions: 'Competition hotel with same name already exists',
  sales_management_branch_competitions_column_mice_event_date: 'Event Months',
  sales_management_branch_competitions_column_mice_event_type: 'Event-type',
  sales_management_branch_competitions_column_mice_event_reminder_days: 'Reminder before days',
  sales_management_branch_contact_name: 'Contact Person',
  lead_management_add_corporate_rate_info: 'Add Corporate Rates',
  lead_management_edit_corporate_rate_info: 'Edit Corporate Rates',
  sales_corporate_rate_email_success: 'Email sent successfully',
  duplicateContact: 'Contact info with same Email id already exists',
  next_follow_up_date: 'Next Follow Up',
  primary_contact_delete_error: 'This is primary contact. First make other contact primary to delete this conatct.',
  primary_contact_tooltip_message: 'This is Primary contact',
  make_primary_contact_tooltip_message: 'Make this contact primary',
  followUpDate: 'Follow-up Date',
  sales_call_follow_up_mode: 'Follow-up Mode',
  sales_call_created_at: 'Created At',
  sales_call_pending_action: 'Pending action',
  sales_call_created_at_after: 'Created After',
  sales_call_created_at_before: 'Created Before',
  sales_call_created_by: 'Created By',
  remarks: 'Discussion Summary',
  taskList: 'Tasks',
  task_list_subtitle: 'Track follow-ups assigned to you and your team.',
  myTasks: 'My Tasks',
  myTeamTasks: 'My Team Tasks',
  tasklist_pending_task: 'Pending task info',
  tasklist_due_date: 'Due Date',
  tasklist_assign_task: 'Assign Task',
  tasklist_title: 'Title',
  tasklist_description: 'Description',
  tasklist_priority: 'Priority',
  taskCompleted: 'Completed',
  markCompleteBtn: 'Mark as complete',
  sales_corporate_rate_email: 'Share Corporate Rates',
  corporateRate: 'Rate',
  corporateRateInclusion: 'Corporate Rate Inclusion',
  issuedBy: 'Issued by',
  validFrom: 'Valid From',
  validto: 'Valid To',
  salesCalls: 'Sales Calls',
  sales_calls_list_subtitle: 'Track sales calls, follow-ups, and cold-call activity.',
  contactedWith: 'Contacted With',
  mySalesCalls: 'My Sales Calls',
  salesCallType: 'Sales Call Type',
  myTeamSalesCalls: 'My Team Sales Calls',
  title: 'Title',
  description: 'Description',
  lead: 'Company',
  noLogAdded: 'No follow-ups added yet.',
  pending: 'Pending',
  addSalesManagement: 'Add Sales Calls',
  editSalesManagement: 'Edit Sales Calls',
  sales_call_who_are_you_calling: 'Who are you calling?',
  sales_call_existing_contact: 'Existing Contact',
  sales_call_new_prospect: 'Cold Call',
  sales_call_prospect_name: 'Name',
  sales_call_prospect_email: 'Email',
  sales_call_prospect_phone: 'Phone',
  sales_call_prospect_company_name: 'Company Name',
  sales_call_prospect_designation: 'Designation',
  show_diary: 'Show Diary',
  organizations_tabs_attributes: 'Localized Attributes',
  organizations_tabs_media_info: 'Media Info',
  organizations_tabs_general: 'General',
  organizations_tabs_mail_configuration: 'Mail Configuration',
  booking_addons: 'Booking Add-ons',
  booking_addons_add: 'Add Booking Add-ons',
  addOnName: 'Add-on Name',
  addOnDescription: 'Description',
  addOnHsnCode: 'Hsn Code',
  hsnCodeInfo: null, // will use this for iconiqa to show hsn codes on info text
  actualQuantity: 'Actual Quantity',
  addOnCategory: 'Add-on Category',
  addOnType: 'Add-on Type',
  price: 'Price',
  taxCode: 'Tax Code',
  taxGroup: 'Tax Group',
  maxCount: 'Max Count',
  initialQuantity: 'Initial Quantity',
  actualizationSummary: 'Actualized Summary',
  actualization_isTransferToRoom: 'Transfer to Room?',
  actualization_roomNumber: 'Guest Room No.',
  actualization_attach_invoice: 'Include latest invoice',
  actualization_latest_invoice: 'Latest generated invoice',
  actualization_attach_file: 'Attach File',
  actualization_send_email_title: 'Send Email',
  actualization_send_thank_you: 'Send Thank You',
  actualization_booked_guests: 'Booked: {0}',
  actualization_guest_variance: '{0} Guests',
  actualization_addon_booked_qty: 'Booked Qty',
  actualization_addon_actual_qty: 'Actual Qty',
  actualization_addon_qty: 'Qty',
  actualization_addon_pricing: 'Pricing',
  actualization_addon_booked_hint: 'Booked: {0}',
  actualization_addon_rate: 'Rate',
  actualization_addon_tax: 'Tax',
  actualization_addon_amount: 'Amount',
  actualization_addon_discount: 'Discount',
  actualization_addon_variance: 'Variance',
  actualization_addon_total: 'Total Add-ons',
  actualization_addon_rate_person: '{0} / person',
  actualization_addon_rate_unit: '{0} / unit',
  actualization_addon_qty_variance: '{0} qty',
  actualization_other_total: 'Total Other Items',
  actualization_ang_total: 'Total A & G',
  actualization_discount_total: 'Total Deductions',
  actualization_discount_flat_hint: 'flat',
  actualization_event_details: 'Event Details',
  actualization_settlement: 'Settlement',
  actualization_accounting: 'Accounting',
  actualization_no_change: 'No change',
  actualization_billable_calculated: 'Calculated',
  actualization_billable_based_on: 'Based on actual / guaranteed',
  actualization_excess_guest_rate_hint: 'Rate: {0} / guest.',
  actualization_excess_guest_count_chip: '{0} guests',
  actualization_reservation_name: 'Reservation Name',
  actualization_reservation_id: 'Reservation ID',
  actualization_tds_percentage: 'TDS Percentage',
  actualization_round_off: 'Round Off',
  actualization_section_addons: 'Add-ons',
  actualization_section_addons_add: 'Add Add-on',
  actualization_section_addons_empty: 'No add-ons added',
  actualization_section_other: 'Other Items',
  actualization_section_other_add: 'Add Other Item',
  actualization_section_other_empty: 'No other items added',
  actualization_section_discount: 'Deductions',
  actualization_section_discount_add: 'Add Deduction',
  actualization_section_discount_empty: 'No deductions added',
  actualization_discount_category_guest_charges: 'Guest Charges',
  actualization_venue_charges: 'Venue Charges',
  actualization_extra_guest_charges: 'Extra Guest Charges',
  actualization_venue_total: 'Venue Total',
  actualization_actual_hint: 'Actual: {0}',
  actualization_deduction_value: 'Value',
  actualization_deduction_remove: 'Remove deduction',
  actualization_section_ang: 'A & G Details',
  actualization_section_ang_add: 'Add A & G',
  actualization_section_ang_empty: 'No A & G details added',
  otherItems: 'Other Items',
  otherItemsAdd: 'Add Other Items',
  angTitle: 'A & G Details',
  discount: 'Deduction',
  discountAdd: 'Add Deductions',
  discountType: 'Deduction Type',
  dropdown_discount_type_flat: 'Flat',
  dropdown_discount_type_percent: 'Percent',
  forbidden: 'Sorry, but you are not authorized to access this feature.Please contact your administrator for access.',
  saveDownloadBeo: 'Save & Download BEO',
  downloadPreviewBeo: 'Download & preview BEO',
  version: 'Version',
  beoReferenceNo: 'Ref. No',
  menu_text_payment_methods: 'Payment Methods',
  paymentMethod_list_subtitle: 'Used when recording and filtering booking payments.',
  paymentMethodName_column_name: 'Name',
  paymentMethodCode_column_name: 'Code',
  paymentMethod_title_add: 'Add Payment method',
  paymentMethod_title_edit: 'Edit Payment method',
  menu_text_addOnCategories: 'Add-on Categories',
  addOnCategory_list_subtitle: 'Used when categorizing add-ons for venues and bookings.',
  addOnCategoryCode_column_name: 'Code',
  addOnCategoryName_column_name: 'Name',
  addOnCategory_title_add: 'Add Add-on Category',
  addOnCategory_title_edit: 'Edit Add-on Category',
  menu_text_serviceCharges: 'Service Charges',
  serviceCharge_button_add: 'Add Service Charge',
  serviceCharge_button_edit: 'Edit Service Charge',
  add_rfq_text_event_type: 'Segment',
  add_rfq_text_guests: 'Number of Guests',
  add_rfq_text_venue: 'Venue',
  add_rfq_text_price_package: 'Price Package',
  add_rfq_text_date: 'Preferred Start Date',
  add_rfq_text_end_date: 'Preferred End Date',
  add_rfq_text_mobile: 'Mobile',
  add_rfq_text_email: 'Email',
  add_rfq_text_company_name: 'Company Name',
  TDS_Deducted: 'TDS Deducted',
  newLineItemAddedSuccessfully: 'New Line Item added successfully',
  addNewLineItem: 'Add New Venue ',
  URL_copied_successfully: 'URL copied successfully.',
  preview_template: 'Preview Template',
  menus_text_industry_type: 'Industry Types',
  industryType: 'Industry Type',
  industryType_title_list: 'Industry Types',
  industryType_list_subtitle: 'Used when classifying companies and sales accounts by industry.',
  industryType_button_add: 'Add Industry Type',
  industryType_button_edit: 'Edit Industry Type',
  addRoomTypeVsCorporateRate: 'Add Room-type Rate Mapping',
  addEditTimeslotRateMappings: 'Add Time-slot Rate Mapping',
  duplicateCorporateRate: 'Corporate rate already exists for specific room type',
  addCall: 'Add Call',
  managedBy: 'Managed by',
  splitRevenue: 'Revenue Allocation',
  splitRevenue_subtitle: 'Allocate booking revenue across venues for reporting.',
  splitRevenue_allocated_label: '{percent}% allocated',
  splitRevenue_split_equally: 'Split Equally',
  splitRevenue_split_equally_body:
    'Distributes the allocation evenly across all included venues, while ensuring the final percentages sum to exactly 100%.',
  splitRevenue_split_equally_example_4: 'Example with 4 venues: 25% / 25% / 25% / 25%',
  splitRevenue_split_equally_example_3:
    'With 3 venues, because of rounding: 33.34% / 33.33% / 33.33%',
  splitRevenue_use_event_revenue: 'Use Event Revenue',
  splitRevenue_use_event_revenue_body:
    "Calculates each venue's split based on that venue/event's share of the total event revenue.",
  splitRevenue_use_event_revenue_formula:
    'Venue Split % = Venue Event Revenue ÷ Total Event Revenue × 100',
  splitRevenue_use_event_revenue_example:
    'Example: Rs. 4L / 3L / 2L / 1L (total Rs. 10L) becomes 40% / 30% / 20% / 10%.',
  splitRevenue_reset: 'Reset',
  splitRevenue_column_venue_event: 'Venue / Event',
  splitRevenue_column_date: 'Date',
  splitRevenue_column_status: 'Status',
  splitRevenue_column_split: 'Split',
  splitRevenue_column_allocated: 'Allocated Revenue',
  splitRevenue_status_actualized: 'Actualized',
  splitRevenue_status_pending: 'Pending',
  splitRevenue_save: 'Save Allocation',
  splitRevenue_incomplete_actualization:
    'Complete remaining actualization to allocate the revenue.',
  SplitRevenuePropsAddSuccessText: 'Revenue splitted successfully',
  greaterThan100Error: 'Value cannot be greater than 100',
  validateStringErrMsg: 'Only letters, numbers, hyphens, underscores, parentheses, commas, and periods are allowed.',
  menu_text_admin_controls: 'Admin Controls',
  changeAssigneeConfirmation: 'Are you sure you want to change the assignee?',
  convertAllToConfirmed: 'Convert all to confirmed booking',
  convertAllToConfirmedSuccess: 'All eligible line items have been converted to confirmed',
  convertAllToConfirmedError: 'Failed to convert line items',
  convertAllToConfirmedConfirmation:
    'Are you sure you want to convert all TENTATIVE and AWAITING_CONFIRMATION line items to CONFIRMED?',
  convertAllToConfirmedTooltip:
    'Only AWAITING_CONFIRMATION and TENTATIVE bookings will be converted to confirmed booking',
  lineItems_text: 'line item(s)',
  sales_report: 'Daily Sales Report',
  sales_report_customer_name: 'Customer Name',
  sales_report_type_of_Call: 'Type of Call',
  sales_report_call_summary: 'Call Summary',
  sales_report_follow_up_date: 'Follow up date',
  sales_report_business_secured: 'Business Secured',
  sales_report_today_sales_reports: 'Todays Sales reports',
  sales_report_name_of_exec: 'Name of Executive',
  sales_report_follow_ups: 'Follow-ups',
  sales_report_no_of_calls: 'No. of Calls',
  sales_report_avg_calls_week: 'Avg. calls/week',
  sales_report_avg_calls_month: 'Avg. calls/month',
  sales_report_avg_calls_today: 'Todays calls',
  sales_report_sales_executive: 'Sales Executive',
  sales_report_no_of_companies: 'No. of companies',
  sales_report_potential: 'Potential',
  sales_report_rpd: 'RPD (Rooms Per Day)',
  sales_report_weekly_sales_report: 'Weekly Sales report',
  sales_report_monthly_sales_report: 'Monthly Sales report',
  sales_call_all_comments: 'See all comments',
  booking_logs_notes: 'Notes',
  booking_logs_follow_ups: 'Follow-ups',
  booking_logs_add_follow_up: 'Add follow-up',
  booking_logs_follow_up_timeline: 'Follow-up Timeline',
  booking_logs_save_follow_up: 'Save Follow-up',
  booking_logs_discussion: 'Discussion / Follow-up Note',
  booking_logs_discussion_placeholder: 'Write the follow-up discussion...',
  booking_logs_summary: 'Summary',
  booking_logs_assigned_to_label: 'Assigned To',
  booking_logs_mode_label: 'Mode',
  booking_logs_created_by_label: 'Created By',
  booking_logs_follow_up_added: 'Follow-up added successfully',
  booking_logs_status_pending: 'PENDING',
  booking_logs_status_completed: 'COMPLETED',
  booking_logs_price_override: 'Request Price Override Approval',
  booking_logs_notes_timeline: 'Notes Timeline',
  booking_logs_add_note: 'Add Note',
  booking_logs_note_placeholder: 'Write an internal note about this booking...',
  booking_logs_attach_file: 'Attach file',
  booking_logs_max_file_size: 'Max file size: 10MB',
  booking_logs_note_added: 'Note added successfully',
  booking_logs_file_too_large: 'File must be 10MB or smaller',
  sales_call_add_comments: 'Save comments',
  sales_calls_add_comment: 'Add Comment',
  sales_calls_add_follow_up: 'Add Follow-up',
  sales_calls_add_button: 'Add Sales Call',
  delete_user_warning_msg:
    'Deletion not allowed: The user is still assigned to active bookings, pending RFQs, tasks, or scheduled sales calls. Please select a user from the dropdown below to transfer all bookings to the new user.',
  kyc_form_title: 'Add KYC Details',
  document_no: 'Document No.',
  kycc_button_title: 'Add KYC Details',
  coldCalls: 'Cold Calls',
  clone_text: 'Clone',
  clone_org_title: 'Clone Organization',
  clone_org_name_label: 'New Organization Name',
  clone_org_data_label: 'Select data to clone',
  clone_org_addons: 'Add-Ons',
  clone_org_price_packages: 'Price Packages',
  clone_org_venues: 'Venues',
  clone_org_venue_configs: 'Venue Configurations',
  clone_org_submit: 'Clone Organization',
  clone_org_success: 'Organization cloned successfully',
};
